const LISTA_FACULDADES = [
  {
    nome: "ACADEMIA DA FORÇA AÉREA",
    sigla: "AFA",
    estado: "SP",
  },
  {
    nome: "ACADEMIA DA POLÍCIA CIVIL DO ESTADO DA BAHIA",
    sigla: "ACADEPOL",
    estado: "BA",
  },
  {
    nome: "ACADEMIA DE POLÍCIA MILITAR DO BARRO BRANCO",
    sigla: "APMBB",
    estado: "SP",
  },
  {
    nome: "ACADEMIA DE POLÍCIA MILITAR DOM JOÃO VI",
    sigla: "APMDJVI",
    estado: "RJ",
  },
  {
    nome: "ACADEMIA DE POLÍCIA MILITAR",
    sigla: "APM",
    estado: "BA",
  },
  {
    nome: "ACADEMIA MILITAR DE AGULHAS NEGRAS",
    sigla: "AMAN",
    estado: "RJ",
  },
  {
    nome: "ANHANGUERA EDUCACIONAL S.A.",
    sigla: "UNIANHANGUERA",
    estado: "RS",
  },
  {
    nome: "ANHANGUERA EDUCACIONAL",
    sigla: "AESA",
    estado: "SP",
  },
  {
    nome: "ASSOCIAÇÃO CATARINENSE DE ENSINO",
    sigla: "ACE",
    estado: "SC",
  },
  {
    nome: "ASSOCIAÇÃO DE ENSINO SUPERIOR DO PIAUÍ",
    sigla: "AESPI",
    estado: "PI",
  },
  {
    nome: "ASSOCIAÇÃO SUL MINEIRA DE EDUCAÇÃO E CULTURA",
    sigla: "ASMEC",
    estado: "MG",
  },
  {
    nome: "ASSOCIAÇÃO VILHENENSE DE EDUCAÇÃO E CULTURA",
    sigla: "AVEC",
    estado: "RO",
  },
  {
    nome: "AVM - FACULDADE INTEGRADA",
    sigla: "IAVM",
    estado: "RJ",
  },
  {
    nome: "BUSINESS SCHOOL SÃO PAULO",
    sigla: "BSP",
    estado: "SP",
  },
  {
    nome: "CATÓLICA NOSSA SENHORA DAS NEVES",
    sigla: "Faculdade",
    estado: "RN",
  },
  {
    nome: "CENTRO DE EDUCAÇÃO DA AMAZÔNIA",
    sigla: "CEAMA",
    estado: "PA",
  },
  {
    nome: "CENTRO DE EDUCAÇÃO SUPERIOR BARNABITA",
    sigla: "CESB",
    estado: "MG",
  },
  {
    nome: "CENTRO DE EDUCAÇÃO TECNOLÓGICO",
    sigla: "CET",
    estado: "PI",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR ARCANJO MIKAEL DE ARAPIRACA",
    sigla: "CESAMA",
    estado: "AL",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR CENECISTA DE FARROUPILHA",
    sigla: "CESF",
    estado: "RS",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE ARCOVERDE",
    sigla: "CESA",
    estado: "PE",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE CATALÃO 1",
    sigla: "CESUC",
    estado: "GO",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE CONSELHEIRO LAFAIETE",
    sigla: "CES-CL",
    estado: "MG",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE ITABIRA",
    sigla: "CENSI",
    estado: "MG",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE JUIZ DE FORA",
    sigla: "CES/JF",
    estado: "MG",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE UBERABA",
    sigla: "CESUBE",
    estado: "MG",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DE VITÓRIA",
    sigla: "CESV",
    estado: "ES",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DO AMAPÁ",
    sigla: "CEAP",
    estado: "AP",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DO VALE DO PARNAÍBA",
    sigla: "CESVALE",
    estado: "PI",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DO VALE DO SÃO FRANCISCO",
    sigla: "CESVASF",
    estado: "PE",
  },
  {
    nome: "CENTRO DE ENSINO SUPERIOR DOS CAMPOS GERAIS",
    sigla: "CESCAGE",
    estado: "PR",
  },
  {
    nome: "CENTRO DE ENSINO UNIFICADO DE TERESINA",
    sigla: "CEUT",
    estado: "PI",
  },
  {
    nome: "CENTRO DE ESTUDOS SUPERIORES APRENDIZ",
    sigla: "CESA",
    estado: "MG",
  },
  {
    nome: "CENTRO DE ESTUDOS SUPERIORES DE MACEIÓ",
    sigla: "CESMAC",
    estado: "AL",
  },
  {
    nome: "CENTRO DE INSTRUÇÃO ALMIRANTE BRAZ DE AGUIAR",
    sigla: "CIABA",
    estado: "PA",
  },
  {
    nome: "CENTRO DE INSTRUÇÃO ALMIRANTE GRAÇA ARANHA",
    sigla: "CIAGA",
    estado: "RJ",
  },
  {
    nome: "CENTRO EDUCACIONAL CONCEIÇÃO NUNES",
    sigla: "CECON",
    estado: "MG",
  },
  {
    nome: "CENTRO FEDERAL DE EDUCAÇÃO TECNOLÓGICA CELSO SUCKOW DA FONSECA",
    sigla: "CEFET/RJ",
    estado: "RJ",
  },
  {
    nome: "CENTRO FEDERAL DE EDUCAÇÃO TECNOLÓGICA DE MINAS GERAIS",
    sigla: "CEFETMG",
    estado: "MG",
  },
  {
    nome: "CENTRO SUPERIOR DE ENSINO E PESQUISA DE MACHADO",
    sigla: "CESEP",
    estado: "MG",
  },
  {
    nome: "CENTRO TÉCNICO-EDUCACIONAL SUPERIOR DO OESTE PARANAENSE",
    sigla: "CTESOP",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERISTÁRIO DA FACULDADE ESTÁCIO DE SÁ DE BELO HORIZONTE",
    sigla: "FESBH",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO - CATÓLICA DE SANTA CATARINA EM JARAGUÁ DO SUL",
    sigla: "Católica em Jaraguá",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ADVENTISTA DE SÃO PAULO",
    sigla: "UNASP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO AMPARENSE",
    sigla: "UNIFIA",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ANHANGUERA DE NITERÓI",
    sigla: "UNIAN",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ANHANGUERA DE SÃO PAULO",
    sigla: "UNIBERO",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ANHANGÜERA",
    sigla: "UNIFIAN",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ANTÔNIO EUFRÁSIO DE TOLEDO DE PRESIDENTE PRUDENTE",
    sigla: "FIAETPP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ASSUNÇÃO",
    sigla: "UNIFAI",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO AUGUSTO MOTTA",
    sigla: "UNISUAM",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO BARÃO DE MAUÁ",
    sigla: "CBM",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO BELAS ARTES DE SÃO PAULO",
    sigla: "FEBASP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CAMPOS DE ANDRADE",
    sigla: "UNIANDRADE",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CARIOCA",
    sigla: "UNICARIOCA",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CATÓLICO SALESIANO AUXILIUM",
    sigla: "UNISALESIANO",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CELSO LISBOA",
    sigla: "UCL",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CENTRAL PAULISTA",
    sigla: "UNICEP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CLARETIANO",
    sigla: "CEUCLAR",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CURITIBA",
    sigla: "UNICURITIBA",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO CÂNDIDO RONDON",
    sigla: "UNIRONDON",
    estado: "MT",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DA CIDADE DO RIO DE JANEIRO",
    sigla: "UNIVERCIDADE",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DA FUNDAÇÃO EDUCACIONAL DE BARRETOS",
    sigla: "UNIFEB",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DA FUNDAÇÃO EDUCACIONAL INACIANA PE SABÓIA DE MEDEIROS",
    sigla: "FEI",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DA GRANDE DOURADOS",
    sigla: "UNIGRAN",
    estado: "MS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DAS FACULDADES ASSOCIADAS DE ENSINO",
    sigla: "UNIFAE",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DAS FACULDADES METROPOLITANAS UNIDAS",
    sigla: "FMU",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE ANÁPOLIS",
    sigla: "UNIEVANGÉLICA",
    estado: "GO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE ARARAQUARA",
    sigla: "UNIARA",
    estado: "TO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE ARARAS - DR. EDMUNDO ULSON",
    sigla: "UNAR",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE BARRA MANSA",
    sigla: "UBM",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE BELFORD ROXO",
    sigla: "UNIABEU",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE BELO HORIZONTE",
    sigla: "UNIBH",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE BRASÍLIA",
    sigla: "CEUB",
    estado: "DF",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE BRUSQUE",
    sigla: "UNIFEBE",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE CAMPO GRANDE",
    sigla: "UNAES",
    estado: "MS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE CARATINGA",
    sigla: "UNEC",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE DESENVOLVIMENTO DO CENTRO OESTE",
    sigla: "UNIDESC",
    estado: "DF",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE ENSINO SUPERIOR DO AMAZONAS",
    sigla: "Ciesa",
    estado: "AM",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE FORMIGA",
    sigla: "UNIFORMG",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE FRANCA",
    sigla: "UniFACEF",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE ITAJUBÁ",
    sigla: "UNIVERSITAS",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE JARAGUÁ DO SUL",
    sigla: "UNERJ",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE JOÃO PESSOA",
    sigla: "UNIPE",
    estado: "PB",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE LAVRAS",
    sigla: "UNILAVRAS",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE MANDAGUARI - UNIMAN",
    sigla: "FAFIMAN",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE MARINGÁ",
    sigla: "CESUMAR",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE MINEIROS",
    sigla: "UNIFIMES",
    estado: "GO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE PATOS DE MINAS",
    sigla: "UNIPAM",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE RIO PRETO",
    sigla: "UNIRP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE SETE LAGOAS MONSENHOR MESSIAS",
    sigla: "UNIFEMM",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE UNIÃO DA VITÓRIA",
    sigla: "UNIUV",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE VOLTA REDONDA",
    sigla: "UNIFOA",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE VOTUPORANGA",
    sigla: "UNIFEV",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DE VÁRZEA GRANDE",
    sigla: "UNIVAG",
    estado: "MT",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DINÂMICA DAS CATARATAS",
    sigla: "UDC",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO CERRADO  PATROCÍNIO",
    sigla: "UNICERP",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO DISTRITO FEDERAL",
    sigla: "UDF",
    estado: "DF",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO ESPÍRITO SANTO",
    sigla: "UNESC",
    estado: "ES",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO INSTITUTO MAUÁ DE TECNOLOGIA",
    sigla: "CEUN-IMT",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO LESTE DE MINAS GERAIS",
    sigla: "UNILESTE/MG",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO MARANHÃO",
    sigla: "UNICEUMA",
    estado: "MA",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO NORTE PAULISTA",
    sigla: "UNORP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO NORTE",
    sigla: "Uninorte",
    estado: "AM",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO PARÁ",
    sigla: "CESUPA",
    estado: "PA",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO PLANALTO DE ARAXÁ",
    sigla: "UNIARAXÁ",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO TRIÂNGULO",
    sigla: "UNITRI",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO DO VALE DO IPOJUCA",
    sigla: "UNIVIP",
    estado: "PE",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ESTÁCIO DA BAHIA",
    sigla: "ESTÁCIO FIB",
    estado: "BA",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ESTÁCIO DE SÁ DE SANTA CATARINA",
    sigla: "FESSC",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ESTÁCIO RADIAL DE SÃO PAULO - ESTÁCIO UNIRADIAL",
    sigla: "ESTÁCIO UNIRADIAL",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO EURO-AMERICANO",
    sigla: "UNIEURO",
    estado: "DF",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO EURÍPEDES DE MARÍLIA",
    sigla: "UNIVEM",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FILADÉLFIA",
    sigla: "UNIFIL",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FLUMINENSE",
    sigla: "UNIFLU",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FRANCISCANO",
    sigla: "UNIFRA",
    estado: "RS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FUNDAÇÃO DE ENSINO OCTÁVIO BASTOS - FEOB",
    sigla: "UNIFEOB",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FUNDAÇÃO INSTITUTO DE ENSINO PARA OSASCO",
    sigla: "UNIFIEO",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO FUNDAÇÃO SANTO ANDRÉ",
    sigla: "CUFSA",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO GERALDO DI BIASE",
    sigla: "UGB",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO HERMINIO OMETTO",
    sigla: "UNIARARAS",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO HERMÍNIO DA SILVEIRA",
    sigla: "UNI IBMR",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO INTERNACIONAL",
    sigla: "UNINTER",
    estado: "PR",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO JORGE AMADO",
    sigla: "UNIJORGE",
    estado: "BA",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO LA SALLE",
    sigla: "UNILASALLE",
    estado: "RS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO LEONARDO DA VINCI",
    sigla: "UNIASSELVI",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO LUTERANO DE JIPARANÁ",
    sigla: "CEULJI/ULBRA",
    estado: "RO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO LUTERANO DE PALMAS",
    sigla: "CEULP/ULBRA",
    estado: "TO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO LUTERANO DE SANTARÉM",
    sigla: "CEULS",
    estado: "PA",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO MAURICIO DE NASSAU",
    sigla: "UNINASSAU",
    estado: "PE",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO METODISTA IZABELA HENDRIX",
    sigla: "CEUNIH",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO METODISTA",
    sigla: "IPA",
    estado: "RS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO METROPOLITANO DE SÃO PAULO",
    sigla: "UNIMESP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO MOACYR SREDER BASTOS",
    sigla: "UNIMSB",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO MONTE SERRAT",
    sigla: "UNIMONTE",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO MOURA LACERDA",
    sigla: "CUML",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO NEWTON PAIVA",
    sigla: "NEWTON PAIVA",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO NILTON LINS",
    sigla: "UNINILTONLINS",
    estado: "AM",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO NOSSA SENHORA DO PATROCÍNIO",
    sigla: "CEUNSP",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO PADRE ANCHIETA",
    sigla: "UNIANCHIETA",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO PARA O DESENVOLVIMENTO DO ALTO VALE DO ITAJAÍ",
    sigla: "UNIDAVI",
    estado: "SC",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO PLANALTO DO DISTRITO FEDERAL",
    sigla: "UNIPLAN",
    estado: "DF",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO RITTER DOS REIS",
    sigla: "UNIRITTER",
    estado: "RS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO SALESIANO DE SÃO PAULO",
    sigla: "UNISAL",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO SANT'ANNA",
    sigla: "UNISANT'ANNA",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO SERRA DOS ÓRGÃOS",
    sigla: "UNIFESO",
    estado: "RJ",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO SÃO CAMILO",
    sigla: "CUSC",
    estado: "ES",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO SÃO CAMILO",
    sigla: "CUSC",
    estado: "SP",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO TIRADENTES",
    sigla: "FITS",
    estado: "AL",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO UNA",
    sigla: "UNA",
    estado: "MG",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO UNIRG",
    sigla: "UnirG",
    estado: "TO",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO UNIVATES",
    sigla: "UNIVATES",
    estado: "RS",
  },
  {
    nome: "CENTRO UNIVERSITÁRIO ÍTALO-BRASILEIRO",
    sigla: "UNIÍTALO",
    estado: "SP",
  },
  {
    nome: "CHRISTUS FACULDADE DO PIAUÍ",
    sigla: "CHRISFAPI",
    estado: "PI",
  },
  {
    nome: "CLARETIANO REDE DE EDUCAÇÃO",
    sigla: "CLARETIANO",
    estado: "RO",
  },
  {
    nome: "CONSERVATÓRIO BRASILEIRO DE MÚSICA - CENTRO UNIVERSITÁRIO",
    sigla: "CBM/CEU",
    estado: "RJ",
  },
  {
    nome: "ESCOLA BAHIANA DE MEDICINA E SAÚDE PÚBLICA",
    sigla: "EBMSP ",
    estado: "BA",
  },
  {
    nome: "ESCOLA BRASILEIRA DE ADMINISTRAÇÃO PÚBLICA E DE EMPRESAS",
    sigla: "EBAPE",
    estado: "RJ",
  },
  {
    nome: "ESCOLA BRASILEIRA DE ECONOMIA E FINANÇAS",
    sigla: "EBEF",
    estado: "RJ",
  },
  {
    nome: "ESCOLA DA CIDADE - FACULDADE DE ARQUITETURA E URBANISMO",
    sigla: "ESCOLA DA CIDADE",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE ADMINISTRAÇÃO DE EMPRESAS DE SÃO PAULO",
    sigla: "FGV-EAESP",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE ADMINISTRAÇÃO DO EXÉRCITO",
    sigla: "ESAEX ",
    estado: "BA",
  },
  {
    nome: "ESCOLA DE DIREITO DE SÃO PAULO",
    sigla: "DIREITO GV",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE DIREITO DO RIO DE JANEIRO",
    sigla: "DIREITO RIO",
    estado: "RJ",
  },
  {
    nome: "ESCOLA DE ECONOMIA DE SÃO PAULO",
    sigla: "EESP",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE EDUCAÇÃO FÍSICA DE ASSIS",
    sigla: "EEFA",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE ENFERMAGEM WENCESLAU BRAZ",
    sigla: "EEWB",
    estado: "MG",
  },
  {
    nome: "ESCOLA DE ENGENHARIA DE PIRACICABA",
    sigla: "EEP/FUMEP",
    estado: "SP",
  },
  {
    nome: "ESCOLA DE ENGENHARIA ELETROMECÂNICA DA BAHIA",
    sigla: "ESEEMB",
    estado: "BA",
  },
  {
    nome: "ESCOLA DE ENGENHARIA KENNEDY",
    sigla: "EEK",
    estado: "MG",
  },
  {
    nome: "ESCOLA DE ENSINO SUPERIOR ANÍSIO TEIXEIRA",
    sigla: "CESAT",
    estado: "ES",
  },
  {
    nome: "ESCOLA DE ESCTUDOS SUPERIORES DE VIÇOSA",
    sigla: "ESUV",
    estado: "MG",
  },
  {
    nome: "ESCOLA DE GOVERNO PROFESSOR PAULO NEVES DE CARVALHO",
    sigla: "EG",
    estado: "MG",
  },
  {
    nome: "ESCOLA DE MÚSICA E BELAS ARTES DO PARANÁ",
    sigla: "EMBAP",
    estado: "PR",
  },
  {
    nome: "ESCOLA NACIONAL DE CIÊNCIAS ESTATÍSTICAS",
    sigla: "ENCE",
    estado: "RJ",
  },
  {
    nome: "ESCOLA NAVAL",
    sigla: "EN",
    estado: "RJ",
  },
  {
    nome: "ESCOLA PERNAMBUCANA DE SAÚDE",
    sigla: "FBVIMIP",
    estado: "PE",
  },
  {
    nome: "ESCOLA POLITÉCNICA DE PERNAMBUCO",
    sigla: "POLI",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR ASSOCIADA DE GOIÂNIA",
    sigla: "ESUP",
    estado: "GO",
  },
  {
    nome: "ESCOLA SUPERIOR BATISTA DO AMAZONAS",
    sigla: "Esbam",
    estado: "AM",
  },
  {
    nome: "ESCOLA SUPERIOR DA AMAZÔNIA",
    sigla: "ESAMAZ",
    estado: "PA",
  },
  {
    nome: "ESCOLA SUPERIOR DE ADMINISTRAÇÃO E GESTÃO",
    sigla: "ESAGS",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE CIÊNCIAS DA SANTA CASA DE MISERICÓRDIA DE VITÓRIA",
    sigla: "EMESCAM",
    estado: "ES",
  },
  {
    nome: "ESCOLA SUPERIOR DE CIÊNCIAS DA SAÚDE",
    sigla: "ESCS",
    estado: "DF",
  },
  {
    nome: "ESCOLA SUPERIOR DE CRICIÚMA - ESUCRI",
    sigla: "ESUCRI",
    estado: "SC",
  },
  {
    nome: "ESCOLA SUPERIOR DE CRUZEIRO PREFEITO HAMILTON VIEIRA MENDES",
    sigla: "ESEFIC",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE EDUCAÇÃO FÍSICA DE JUNDIAÍ",
    sigla: "ESEFJ",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE EDUCAÇÃO FÍSICA",
    sigla: "ESEF",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR DE ENGENHARIA E GESTÃO DE SÃO PAULO - ESEG",
    sigla: "ESEG",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE ENSINO HELENA ANTIPOFF",
    sigla: "ESEHA",
    estado: "RJ",
  },
  {
    nome: "ESCOLA SUPERIOR DE ESTUDOS EMPRESARIAIS E INFORMÁTICA",
    sigla: "ESEEI",
    estado: "PR",
  },
  {
    nome: "ESCOLA SUPERIOR DE GESTÃO COMERCIAL E MARKETING",
    sigla: "ESIC",
    estado: "PR",
  },
  {
    nome: "ESCOLA SUPERIOR DE HOTELARIA CASTELLI",
    sigla: "CASTELLI",
    estado: "RS",
  },
  {
    nome: "ESCOLA SUPERIOR DE MARKETING",
    sigla: "ESM",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR DE MÚSICA E ARTES DO RIO GRANDE DO SUL",
    sigla: "ESMARGS",
    estado: "RS",
  },
  {
    nome: "ESCOLA SUPERIOR DE PROPAGANDA E MARKETING",
    sigla: "ESPM",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE RELAÇÕES PÚBLICAS",
    sigla: "Esurp",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR DE SAÚDE DE ARCOVERDE",
    sigla: "ESSA",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR DE SECRETARIADO DE PERNAMBUCO",
    sigla: "ESUSPE",
    estado: "PE",
  },
  {
    nome: "ESCOLA SUPERIOR DE TECNOLOGIA E EDUCAÇÃO DE PORTO FERREIRA",
    sigla: "ESPF",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DE TECNOLOGIA E EDUCAÇÃO DE RIO CLARO",
    sigla: "ESRC",
    estado: "SP",
  },
  {
    nome: "ESCOLA SUPERIOR DOM HELDER CÂMARA",
    sigla: "ESDHC",
    estado: "MG",
  },
  {
    nome: "ESCOLA SUPERIOR EM MEIO AMBIENTE",
    sigla: "ESMA",
    estado: "MG",
  },
  {
    nome: "ESCOLA SUPERIOR MADRE CELESTE",
    sigla: "ESMAC",
    estado: "PA",
  },
  {
    nome: "ESCOLA SUPERIOR NACIONAL DE SEGUROS",
    sigla: "ESNS",
    estado: "RJ",
  },
  {
    nome: "ESCOLA SUPERIOR SÃO FRANCISCO DE ASSIS",
    sigla: "ESFA",
    estado: "ES",
  },
  {
    nome: "ESCOLA TÉCNICA E SUPERIOR MACHADO DE ASSIS  SANTA ROSA",
    sigla: "FEMA",
    estado: "RS",
  },
  {
    nome: "ESTÁCIO DE SÁ  FACULDADE DO PARÁ",
    sigla: "ESTÁCIO FAP",
    estado: "PA",
  },
  {
    nome: "ESTÁCIO FATERN - FACULDADE ESTÁCIO DO RIO GRANDE DO NORTE",
    sigla: "ESTÁCIO FATERN",
    estado: "RN",
  },
  {
    nome: "FACISA-UNAI FACULDADE DE CIÊNCIAS DA SAÚDE DE UNAÍ",
    sigla: "FACISA-UNAI",
    estado: "MG",
  },
  {
    nome: "FACULDADE 7 DE SETEMBRO",
    sigla: "Fa7",
    estado: "CE",
  },
  {
    nome: "FACULDADE ADELMAR ROSADO",
    sigla: "FAR",
    estado: "PI",
  },
  {
    nome: "FACULDADE ADVENTISTA DA BAHIA",
    sigla: "FADBA ",
    estado: "BA",
  },
  {
    nome: "FACULDADE ADVENTISTA DE HORTOLÂNDIA",
    sigla: "FAH",
    estado: "SP",
  },
  {
    nome: "FACULDADE ADVENTISTA PARANAENSE",
    sigla: "IAP",
    estado: "PR",
  },
  {
    nome: "FACULDADE AFIRMATIVO",
    sigla: "FAFI",
    estado: "MT",
  },
  {
    nome: "FACULDADE AIEC",
    sigla: "AIEC / FAAB",
    estado: "DF",
  },
  {
    nome: "FACULDADE ALAGOANA DE ADMINISTRAÇÃO",
    sigla: "FAA",
    estado: "AL",
  },
  {
    nome: "FACULDADE ALBERT EINSTEIN",
    sigla: "FALBE",
    estado: "DF",
  },
  {
    nome: "FACULDADE ALDETE MARIA ALVES",
    sigla: "FAMA",
    estado: "MG",
  },
  {
    nome: "FACULDADE ALFA BRASIL",
    sigla: "FAAB",
    estado: "PR",
  },
  {
    nome: "FACULDADE ALFACASTELO",
    sigla: "FCGB",
    estado: "SP",
  },
  {
    nome: "FACULDADE ALFREDO NASSER",
    sigla: "FAN",
    estado: "GO",
  },
  {
    nome: "FACULDADE ALIANÇA",
    sigla: "ALIANÇA",
    estado: "PI",
  },
  {
    nome: "FACULDADE ALMEIDA RODRIGUES",
    sigla: "FAR",
    estado: "GO",
  },
  {
    nome: "FACULDADE ALVES FARIA",
    sigla: "ALFA",
    estado: "GO",
  },
  {
    nome: "FACULDADE ALVORADA DE EDUCAÇÃO FÍSICA E DESPORTO",
    sigla: "FAEFD",
    estado: "DF",
  },
  {
    nome: "FACULDADE ALVORADA DE TECNOLOGIA E EDUCAÇÃO DE MARINGÁ",
    sigla: "FACULDADE ALVORADA",
    estado: "PR",
  },
  {
    nome: "FACULDADE AMADEUS",
    sigla: "FAMA",
    estado: "SE",
  },
  {
    nome: "FACULDADE AMEC TRABUCO",
    sigla: "AMAEC ",
    estado: "BA",
  },
  {
    nome: "FACULDADE ANCHIETA DE ENSINO SUPERIOR DO PARANÁ",
    sigla: "FAESP",
    estado: "PR",
  },
  {
    nome: "FACULDADE ANCHIETA DO RECIFE",
    sigla: "FAR",
    estado: "PE",
  },
  {
    nome: "FACULDADE ANCHIETA",
    sigla: "IGABC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANGLICANA DE ERECHIM",
    sigla: "FAE",
    estado: "RS",
  },
  {
    nome: "FACULDADE ANGLO-AMERICANO DE JOÃO PESSOA",
    sigla: "FAAJP",
    estado: "PB",
  },
  {
    nome: "FACULDADE ANGLO-AMERICANO",
    sigla: "FAA",
    estado: "PR",
  },
  {
    nome: "FACULDADE ANGLOAMERICANO DE CAXIAS DO SUL",
    sigla: "FAACS",
    estado: "RS",
  },
  {
    nome: "FACULDADE ANHANGUERA DE ANÁPOLIS",
    sigla: "FAA",
    estado: "GO",
  },
  {
    nome: "FACULDADE ANHANGUERA DE BRASÍLIA",
    sigla: "FAB",
    estado: "DF",
  },
  {
    nome: "FACULDADE ANHANGUERA DE CASCAVEL",
    sigla: "FACIAP",
    estado: "PR",
  },
  {
    nome: "FACULDADE ANHANGUERA DE CAXIAS DO SUL",
    sigla: "FACS",
    estado: "RS",
  },
  {
    nome: "FACULDADE ANHANGUERA DE CIÊNCIAS E TECNOLOGIA DE BRASÍLIA",
    sigla: "FACITEB",
    estado: "DF",
  },
  {
    nome: "FACULDADE ANHANGUERA DE CUIABÁ",
    sigla: "FAC",
    estado: "MT",
  },
  {
    nome: "FACULDADE ANHANGUERA DE EDUCAÇÃO CIÊNCIAS E TECNOLOGIA DE SOROCABA",
    sigla: "FAECTS",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE GUARULHOS",
    sigla: "FIT",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE NEGÓCIOS E TECNOLOGIAS DA INFORMAÇÃO",
    sigla: "FACNET",
    estado: "DF",
  },
  {
    nome: "FACULDADE ANHANGUERA DE OSASCO",
    sigla: "FIZO",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE SERTÃOZINHO",
    sigla: "FASERT",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE SUMARÉ",
    sigla: "FACSUMARÉ",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE SÃO BERNARDO",
    sigla: "FASBC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE SÃO CAETANO",
    sigla: "Fasc",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE TABOÃO DA SERRA",
    sigla: "FATS",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE TAGUATINGA",
    sigla: "FAST",
    estado: "DF",
  },
  {
    nome: "FACULDADE ANHANGUERA DE TECNOLOGIA DE JUNDUAÍ",
    sigla: "FATJ",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANHANGUERA DE VALPARAÍSO",
    sigla: "FAV",
    estado: "GO",
  },
  {
    nome: "FACULDADE ANHANGUERA JARAGUÁ DO SUL",
    sigla: "FATEJA",
    estado: "SC",
  },
  {
    nome: "FACULDADE ANHANGÜERA DE DOURADOS",
    sigla: "FAD",
    estado: "MS",
  },
  {
    nome: "FACULDADE ANHANGÜERA DE SOROCABA",
    sigla: "FSO",
    estado: "SP",
  },
  {
    nome: "FACULDADE ANTONIO MENEGHETTI",
    sigla: "FAM",
    estado: "RS",
  },
  {
    nome: "FACULDADE ANÍSIO TEIXEIRA DE FEIRA DE SANTANA",
    sigla: "FAT",
    estado: "BA",
  },
  {
    nome: "FACULDADE APOGEU",
    sigla: "APOGEU",
    estado: "DF",
  },
  {
    nome: "FACULDADE ARAGUAIA",
    sigla: "FARA",
    estado: "GO",
  },
  {
    nome: "FACULDADE ARNALDO HORÁCIO FERREIRA",
    sigla: "FAAHF",
    estado: "BA",
  },
  {
    nome: "FACULDADE ARQUIDIOCESANA DE CURVELO",
    sigla: "FAC",
    estado: "MG",
  },
  {
    nome: "FACULDADE ARTHUR SÁ EARP NETO",
    sigla: "FASE",
    estado: "RJ",
  },
  {
    nome: "FACULDADE ARTHUR THOMAS",
    sigla: "CESA",
    estado: "PR",
  },
  {
    nome: "FACULDADE ASA DE BRUMADINHO",
    sigla: "IECEMB - FAB",
    estado: "MG",
  },
  {
    nome: "FACULDADE ASCES",
    sigla: "ASCES",
    estado: "PE",
  },
  {
    nome: "FACULDADE ASSIS GURGACZ",
    sigla: "FAG",
    estado: "PR",
  },
  {
    nome: "FACULDADE ASSOCIADA BRASIL",
    sigla: "FAB",
    estado: "SP",
  },
  {
    nome: "FACULDADE ASTORGA",
    sigla: "FAAST",
    estado: "PR",
  },
  {
    nome: "FACULDADE ATENAS MARANHENSE",
    sigla: "FAMA",
    estado: "MA",
  },
  {
    nome: "FACULDADE ATENEU",
    sigla: "FATE",
    estado: "DF",
  },
  {
    nome: "FACULDADE ATLÂNTICO",
    sigla: "ATLANTICO",
    estado: "SE",
  },
  {
    nome: "FACULDADE ATUAL",
    sigla: "FAAT",
    estado: "AP",
  },
  {
    nome: "FACULDADE AUTÔNOMA DE DIREITO",
    sigla: "FADISP",
    estado: "SP",
  },
  {
    nome: "FACULDADE AVANTIS",
    sigla: "AVANTIS",
    estado: "SC",
  },
  {
    nome: "FACULDADE AVEC DE VILHENA",
    sigla: "AVEC",
    estado: "RO",
  },
  {
    nome: "FACULDADE AÇÃO",
    sigla: "FCTVALE",
    estado: "SC",
  },
  {
    nome: "FACULDADE BAIANA DE CIÊNCIAS CONTÁBEIS",
    sigla: "FABAC ",
    estado: "BA",
  },
  {
    nome: "FACULDADE BAIANA DE DIREITO",
    sigla: "FBD",
    estado: "BA",
  },
  {
    nome: "FACULDADE BARDDAL DE ARTES APLICADAS",
    sigla: "FB-AA",
    estado: "SC",
  },
  {
    nome: "FACULDADE BARDDAL",
    sigla: "FB-SI",
    estado: "SC",
  },
  {
    nome: "FACULDADE BARRETOS",
    sigla: "FB",
    estado: "SP",
  },
  {
    nome: "FACULDADE BARÃO DO RIO BRANCO",
    sigla: "FAB",
    estado: "AC",
  },
  {
    nome: "FACULDADE BATISTA BRASILEIRA",
    sigla: "FBB",
    estado: "BA",
  },
  {
    nome: "FACULDADE BATISTA BRASILEIRA",
    sigla: "FBB",
    estado: "BA",
  },
  {
    nome: "FACULDADE BATISTA DE MINAS GERAIS",
    sigla: "FBMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE BATISTA DE VITORIA",
    sigla: "FABAVI",
    estado: "ES",
  },
  {
    nome: "FACULDADE BATISTA DO RIO DE JANEIRO",
    sigla: "FABAT",
    estado: "RJ",
  },
  {
    nome: "FACULDADE BERTIOGA",
    sigla: "FABE",
    estado: "SP",
  },
  {
    nome: "FACULDADE BETIM",
    sigla: "FABE",
    estado: "MG",
  },
  {
    nome: "FACULDADE BEZERRA DE ARAÚJO",
    sigla: "FABA",
    estado: "RJ",
  },
  {
    nome: "FACULDADE BIRIGUI",
    sigla: "FABI",
    estado: "SP",
  },
  {
    nome: "FACULDADE BOA VIAGEM",
    sigla: "FBV",
    estado: "PE",
  },
  {
    nome: "FACULDADE BOAS NOVAS DE CIÊNCIAS TEOLÓGICAS SOCIAIS E BIOTECNOLÓGICAS",
    sigla: "FBNCTSB",
    estado: "AM",
  },
  {
    nome: "FACULDADE BORGES DE MENDONÇA",
    sigla: "FBM",
    estado: "SC",
  },
  {
    nome: "FACULDADE BRASIL CENTRAL",
    sigla: "FBC",
    estado: "GO",
  },
  {
    nome: "FACULDADE BRASIL NORTE",
    sigla: "FABRAN",
    estado: "AP",
  },
  {
    nome: "FACULDADE BRASILEIRA DE EDUCAÇÃO E CULTURA",
    sigla: "FABEC BRASIL",
    estado: "GO",
  },
  {
    nome: "FACULDADE BRASILEIRA",
    sigla: "MULTIVIX VITÓRIA",
    estado: "ES",
  },
  {
    nome: "FACULDADE BRASILEIRA",
    sigla: "UNIVIX",
    estado: "ES",
  },
  {
    nome: "FACULDADE BRASÍLIA DE SÃO PAULO",
    sigla: "FABRASP",
    estado: "SP",
  },
  {
    nome: "FACULDADE BÉTHENCOURT DA SILVA",
    sigla: "FABES",
    estado: "RJ",
  },
  {
    nome: "FACULDADE CALAFIORI",
    sigla: "CALAFIORI",
    estado: "MG",
  },
  {
    nome: "FACULDADE CAMAQÜENSE DE CIÊNCIAS CONTÁBEIS E ADMINISTRATIVAS",
    sigla: "FACCCA",
    estado: "RS",
  },
  {
    nome: "FACULDADE CAMBURY",
    sigla: "CAMBURY",
    estado: "GO",
  },
  {
    nome: "FACULDADE CAMPO GRANDE",
    sigla: "FCG",
    estado: "MS",
  },
  {
    nome: "FACULDADE CAMPO REAL",
    sigla: "CAMPO REAL",
    estado: "PR",
  },
  {
    nome: "FACULDADE CAMPOS ELÍSEOS",
    sigla: "FCE",
    estado: "SP",
  },
  {
    nome: "FACULDADE CANDIDO MENDES DE VITÓRIA",
    sigla: "FCMV",
    estado: "ES",
  },
  {
    nome: "FACULDADE CAPIVARI",
    sigla: "FUCAP",
    estado: "SC",
  },
  {
    nome: "FACULDADE CAPIXABA DA SERRA",
    sigla: "MULTIVIX SERRA",
    estado: "ES",
  },
  {
    nome: "FACULDADE CAPIXABA DE NOVA VENÉCIA",
    sigla: "MULTIVIX NOVA VENÉCI",
    estado: "ES",
  },
  {
    nome: "FACULDADE CARLOS DRUMMOND DE ANDRADE",
    sigla: "FCDA",
    estado: "SP",
  },
  {
    nome: "FACULDADE CASA BRANCA",
    sigla: "FACAB",
    estado: "SP",
  },
  {
    nome: "FACULDADE CASA DO ESTUDANTE",
    sigla: "FACE",
    estado: "ES",
  },
  {
    nome: "FACULDADE CASTELO BRANCO",
    sigla: "FCB",
    estado: "ES",
  },
  {
    nome: "FACULDADE CASTRO ALVES",
    sigla: "FCA",
    estado: "BA",
  },
  {
    nome: "FACULDADE CATUAÍ",
    sigla: "ICES",
    estado: "PR",
  },
  {
    nome: "FACULDADE CATÓLICA DE ANÁPOLIS",
    sigla: "Fac",
    estado: "GO",
  },
  {
    nome: "FACULDADE CATÓLICA DE CIÊNCIAS ECONÔMICAS DA BAHIA",
    sigla: "FACCEBA",
    estado: "BA",
  },
  {
    nome: "FACULDADE CATÓLICA DE FORTALEZA",
    sigla: "FCF",
    estado: "CE",
  },
  {
    nome: "FACULDADE CATÓLICA DE POUSO ALEGRE",
    sigla: "FACAPA",
    estado: "MG",
  },
  {
    nome: "FACULDADE CATÓLICA DE RONDONIA",
    sigla: "FCR",
    estado: "RO",
  },
  {
    nome: "FACULDADE CATÓLICA DE UBERLÂNDIA",
    sigla: "FCU",
    estado: "MG",
  },
  {
    nome: "FACULDADE CATÓLICA DO CEARÁ",
    sigla: "FCC",
    estado: "CE",
  },
  {
    nome: "FACULDADE CATÓLICA DO TOCANTINS",
    sigla: "FACTO",
    estado: "TO",
  },
  {
    nome: "FACULDADE CATÓLICA DOM ORIONE",
    sigla: "FACDO",
    estado: "TO",
  },
  {
    nome: "FACULDADE CATÓLICA RAINHA DA PAZ DE ARAPUTANGA",
    sigla: "FCARP",
    estado: "MT",
  },
  {
    nome: "FACULDADE CATÓLICA RAINHA DO SERTÃO",
    sigla: "FCRS",
    estado: "CE",
  },
  {
    nome: "FACULDADE CATÓLICA SANTA TERESINHA",
    sigla: "FCST",
    estado: "RN",
  },
  {
    nome: "FACULDADE CCAA",
    sigla: "FAC CCAA",
    estado: "RJ",
  },
  {
    nome: "FACULDADE CECAP DO LAGO NORTE",
    sigla: "CECAP",
    estado: "DF",
  },
  {
    nome: "FACULDADE CENECISTA DE BENTO GONÇALVES",
    sigla: "FACEBG",
    estado: "RS",
  },
  {
    nome: "FACULDADE CENECISTA DE CAMPO LARGO",
    sigla: "FACECLA",
    estado: "PR",
  },
  {
    nome: "FACULDADE CENECISTA DE ITABORAÍ",
    sigla: "FACNEC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE CENECISTA DE JOINVILLE - FACE",
    sigla: "FCJ",
    estado: "SC",
  },
  {
    nome: "FACULDADE CENECISTA DE NOVA PETRÓPOLIS",
    sigla: "FACENP",
    estado: "RS",
  },
  {
    nome: "FACULDADE CENECISTA DE OSÓRIO",
    sigla: "FACOS",
    estado: "RS",
  },
  {
    nome: "FACULDADE CENECISTA DE RIO DAS OSTRAS",
    sigla: "FCRO",
    estado: "RJ",
  },
  {
    nome: "FACULDADE CENECISTA DE RONDONÓPOLIS",
    sigla: "FACER",
    estado: "MT",
  },
  {
    nome: "FACULDADE CENECISTA DE SETE LAGOAS",
    sigla: "FCSL",
    estado: "MG",
  },
  {
    nome: "FACULDADE CENECISTA DE SINOP",
    sigla: "FACENOP",
    estado: "MT",
  },
  {
    nome: "FACULDADE CENECISTA DE VARGINHA",
    sigla: "FACECA",
    estado: "MG",
  },
  {
    nome: "FACULDADE CENECISTA DE VILA VELHA",
    sigla: "FACEVV",
    estado: "ES",
  },
  {
    nome: "FACULDADE CENECISTA ILHA DO GOVERNADOR",
    sigla: "FACIG",
    estado: "RJ",
  },
  {
    nome: "FACULDADE CENECISTA NOSSA SENHORA DOS ANJOS",
    sigla: "FACENSA",
    estado: "RS",
  },
  {
    nome: "FACULDADE CENTRAL DE CRISTALINA",
    sigla: "FACEC",
    estado: "GO",
  },
  {
    nome: "FACULDADE CENTRO OESTE",
    sigla: "FACEOPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE CENTRO PAULISTA",
    sigla: "CESI",
    estado: "SP",
  },
  {
    nome: "FACULDADE CESMAC DO SERTÃO",
    sigla: "CESMAC Sertão",
    estado: "AL",
  },
  {
    nome: "FACULDADE CHRISTUS",
    sigla: "UNICHRISTUS",
    estado: "CE",
  },
  {
    nome: "FACULDADE CIDADE DE COROMANDEL",
    sigla: "FCC",
    estado: "MG",
  },
  {
    nome: "FACULDADE CIDADE DE JOÃO PINHEIRO",
    sigla: "FCJP",
    estado: "MG",
  },
  {
    nome: "FACULDADE CIDADE DE PATOS DE MINAS",
    sigla: "FPM",
    estado: "MG",
  },
  {
    nome: "FACULDADE CIDADE DO SALVADOR",
    sigla: "FCS",
    estado: "BA",
  },
  {
    nome: "FACULDADE CIDADE LUZ",
    sigla: "FACILUZ",
    estado: "SP",
  },
  {
    nome: "FACULDADE CIDADE VERDE",
    sigla: "FCV",
    estado: "PR",
  },
  {
    nome: "FACULDADE CIÊNCIAS DA VIDA",
    sigla: "FCV",
    estado: "MG",
  },
  {
    nome: "FACULDADE CONCÓRDIA",
    sigla: "FACC",
    estado: "SC",
  },
  {
    nome: "FACULDADE CORPORATIVA CESPI",
    sigla: "FACESPI",
    estado: "SP",
  },
  {
    nome: "FACULDADE COTEMIG",
    sigla: "COTEMIG",
    estado: "MG",
  },
  {
    nome: "FACULDADE CRISTO REI",
    sigla: "FACCREI",
    estado: "PR",
  },
  {
    nome: "FACULDADE CRUZ AZUL",
    sigla: "FACRAZ",
    estado: "SP",
  },
  {
    nome: "FACULDADE CUIABÁ",
    sigla: "FAUC",
    estado: "MT",
  },
  {
    nome: "FACULDADE CÁSPER LÍBERO",
    sigla: "FCL",
    estado: "SP",
  },
  {
    nome: "FACULDADE CÂMARA CASCUDO",
    sigla: "FCC",
    estado: "RN",
  },
  {
    nome: "FACULDADE CÂNDIDO RONDON - FCR",
    sigla: "FCR",
    estado: "MT",
  },
  {
    nome: "FACULDADE DA ALDEIA DE CARAPICUÍBA",
    sigla: "FALC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DA ALTA PAULISTA",
    sigla: "FAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DA AMAZÔNIA OCIDENTAL",
    sigla: "FAAO",
    estado: "AC",
  },
  {
    nome: "FACULDADE DA AMAZÔNIA",
    sigla: "FAMA",
    estado: "RO",
  },
  {
    nome: "FACULDADE DA CIDADE DE MACEIÓ",
    sigla: "FACIMA",
    estado: "AL",
  },
  {
    nome: "FACULDADE DA CIDADE DE SANTA LUZIA",
    sigla: "FACSAL",
    estado: "MG",
  },
  {
    nome: "FACULDADE DA ESCADA",
    sigla: "FAESC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DA REGIÃO DOS LAGOS",
    sigla: "FERLAGOS",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DA REGIÃO SERRANA",
    sigla: "FARESE",
    estado: "ES",
  },
  {
    nome: "FACULDADE DA SAÚDE E ECOLOGIA HUMANA",
    sigla: "FASEH",
    estado: "MG",
  },
  {
    nome: "FACULDADE DA SERRA GAÚCHA",
    sigla: "FSG",
    estado: "RS",
  },
  {
    nome: "FACULDADE DA SERRA",
    sigla: "FASE",
    estado: "ES",
  },
  {
    nome: "FACULDADE DA SEUNE",
    sigla: "SEUNE",
    estado: "AL",
  },
  {
    nome: "FACULDADE DAMAS DA INSTRUÇÃO CRISTÃ",
    sigla: "FADIC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DAMÁSIO",
    sigla: "FD",
    estado: "SP",
  },
  {
    nome: "FACULDADE DARCY RIBEIRO",
    sigla: "FADR",
    estado: "CE",
  },
  {
    nome: "FACULDADE DAS AMÉRICAS",
    sigla: "FAM",
    estado: "SP",
  },
  {
    nome: "FACULDADE DAS ATIVIDADES EMPRESARIAIS DE TERESINA",
    sigla: "FAETE",
    estado: "PI",
  },
  {
    nome: "FACULDADE DAS ÁGUAS EMENDADAS - FAE",
    sigla: "FAE",
    estado: "DF",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO CIÊNCIAS ECON E CONTÁBEIS DE GUARATINGUETÁ",
    sigla: "FACEAG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO CIÊNCIAS EDUCAÇÃO E LETRAS",
    sigla: "FACEL",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DA ASSOCIAÇÃO BRASILIENSE DE EDUCAÇÃO",
    sigla: "FABE",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DA FESPSP",
    sigla: "FADFESPSP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DA FUNDAÇÃO ARMANDO ALVARES PENTEADO",
    sigla: "FAE-FAAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE CAMPO BELO",
    sigla: "FACAMP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE CATAGUASES",
    sigla: "UNIPACAT",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE CHAPADÃO DO SUL",
    sigla: "FACHASUL",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE GOVERNADOR VALADARES",
    sigla: "FAGV",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE ITABIRITO",
    sigla: "FAI",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE NOVA ANDRADINA - FANOVA",
    sigla: "FANOVA",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE PASSOS",
    sigla: "FAP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE SANTA CRUZ DO RIO PARDO",
    sigla: "FASC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE SÃO JOSÉ DO RIO PRETO",
    sigla: "FACMIL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO DE TERESINA",
    sigla: "FAT",
    estado: "PI",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO E ARTES DE LIMEIRA",
    sigla: "FAAL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO E CIÊNCIAS CONTÁBEIS DE SÃO ROQUE",
    sigla: "FACCSR",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO E INFORMÁTICA PAULISTA",
    sigla: "FIAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ADMINISTRAÇÃO E NEGÓCIOS DE SERGIPE",
    sigla: "FANESE",
    estado: "SE",
  },
  {
    nome: "FACULDADE DE AGRONEGÓCIO PARAÍSO DO NORTE",
    sigla: "FAPAN",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE AGRONOMIA E ENGENHARIA FLORESTAL DE GARÇA",
    sigla: "FAEF",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE AGUDOS",
    sigla: "FAAG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ALMENARA",
    sigla: "ALFA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ALTA FLORESTA",
    sigla: "FAF",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE AMAMBAI",
    sigla: "FIAMA",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE AMERICANA",
    sigla: "FAM",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE AMPÉRE",
    sigla: "FAMPER",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE APUCARANA",
    sigla: "FAP",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE ARACAJU",
    sigla: "FACAR",
    estado: "SE",
  },
  {
    nome: "FACULDADE DE ARACRUZ",
    sigla: "FAACZ",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE ARARAQUARA",
    sigla: "FARA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ARQUITETURA E URBANISMO DE PERNAMBUCO",
    sigla: "FAUPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ARTES CIÊNCIAS E TECNOLOGIAS",
    sigla: "FACET ",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE ARTES DO PARANÁ",
    sigla: "FAP",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE ARUJÁ",
    sigla: "FAR",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE AURIFLAMA",
    sigla: "FAU",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE BALSAS",
    sigla: "UNIBALSAS",
    estado: "MA",
  },
  {
    nome: "FACULDADE DE BELFORD ROXO",
    sigla: "FABEL",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE BELÉM",
    sigla: "FABEL",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE CAFELÂNDIA",
    sigla: "FAC",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE CALDAS NOVAS",
    sigla: "UNICALDAS",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE CAMPINA GRANDE DO SUL",
    sigla: "FACSUL",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE CAMPO LIMPO PAULISTA",
    sigla: "FACCAMP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CARIACICA",
    sigla: "FAC DE CARIACICA",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE CASTANHAL",
    sigla: "FCAT",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE CASTELO",
    sigla: "FACASTELO",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE CERES",
    sigla: "FACERES",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE CIENCIAS HUMANAS E SOCIAIS DE SERRA TALHADA",
    sigla: "FACHUSST",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIA E EDUCAÇÃO DO CAPARAÓ",
    sigla: "FACEC",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE CIÊNCIA E TECNOLOGIA DE CARUARU",
    sigla: "FACITEC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIA E TECNOLOGIA DO PLANALTO CENTRAL",
    sigla: "FACIPLAC",
    estado: "DF",
  },
  {
    nome: "FACULDADE DE CIÊNCIA E TECNOLOGIA",
    sigla: "ÁREA1",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS AGRÁRIAS DE ANDRADINA",
    sigla: "FCAA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS AGRÁRIAS DE ARARIPINA",
    sigla: "FACIAGRA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS AGRÁRIAS E DA SAÚDE",
    sigla: "FAS",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS AGRÁRIAS E EXATAS DE PRIMAVERA DO LESTE",
    sigla: "FCAE",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS APLICADAS DOUTOR LEÃO SAMPAIO",
    sigla: "Fals",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS APLICADAS E SOCIAIS DE PETROLINA",
    sigla: "FACAPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS BIOMÉDICAS DE CACOAL",
    sigla: "FACIMED",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS BIOMÉDICAS DO ESPÍRITO SANTO",
    sigla: "PIO XII - BIO",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTABEIS DE DIVINÓPOLIS",
    sigla: "FACED",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS DE ITAPETININGA",
    sigla: "FCCI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS DE NOVA ANDRADINA - FACINAN",
    sigla: "FACINAN",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS DE RECIFE",
    sigla: "FACCOR",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS E ADMINISTRATIVAS DE CACHOEIRO DO ITAPEMIRIM",
    sigla: "FACCACI",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS E DE ADMINISTRAÇÃO DO VALE DO JURUENA",
    sigla: "AJES",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CONTÁBEIS LUIZ MENDES",
    sigla: "LUMEN FACULDADES",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS CULTURA E EXTENSÃO DO RN",
    sigla: "Facex",
    estado: "RN",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA ADMINISTRAÇÃO DE GARANHUNS",
    sigla: "FAGA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA ADMINISTRAÇÃO DE PERNAMBUCO",
    sigla: "FCAP",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA ADMINISTRAÇÃO DO LIMOEIRO",
    sigla: "FACAL",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA BAHIA",
    sigla: "FACIBA",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA SAÚDE ARCHIMEDES THEODORO",
    sigla: "FAC - SAUDE ARTHE",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA SAÚDE DE BARRETOS DR. PAULO PRATA",
    sigla: "FCSB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DA SAÚDE DE CAMPOS GERAIS",
    sigla: "FACICA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DE GUARULHOS",
    sigla: "FACIG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DE RUBIATABA",
    sigla: "FACER",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DE TIMBAÚBA",
    sigla: "FACET",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DE WENCESLAU BRAZ",
    sigla: "FACIBRA",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS DO TOCANTINS",
    sigla: "FACIT",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E CULTURA DA BAHIA",
    sigla: "FCCB",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E CULTURA DE CAJAZEIRAS",
    sigla: "FCCC",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E EDUCAÇÃO SENA AIRES",
    sigla: "FACESA",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E LETRAS DE BRAGANÇA PAULISTA",
    sigla: "FESB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E SAÚDE DE SERRA TALHADA",
    sigla: "FACISST",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E TECNOLOGIA DE BIRIGUI",
    sigla: "FATEB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E TECNOLOGIA DE UNAÍ",
    sigla: "FACTU",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS E TECNOLOGIA DO MARANHÃO",
    sigla: "FACEMA",
    estado: "MA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS ADMINISTRATIVAS E CONTÁBEIS DE DIVINÓPOLIS",
    sigla: "FACED",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS ADMINISTRATIVAS E DA COMPUTAÇÃO DOM BOSCO",
    sigla: "FCEACDB",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS DA REGIÃO CARBONÍFERA",
    sigla: "FACIERC",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS DO TRIÂNGULO MINEIRO",
    sigla: "FCETM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS E ADMINISTRATIVAS SANTA RITA DE CÁSSIA",
    sigla: "FACEAS",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS ECONÔMICAS",
    sigla: "FACAMP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EDUCACIONAIS DE CAPIM GROSSO",
    sigla: "FCG",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EDUCACIONAIS E SISTEMAS INTEGRADOS",
    sigla: "FACESI",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EDUCAÇÃO E TECNOLOGIA DE GARANHUNS",
    sigla: "FACETEG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EDUCAÇÃO E TEOLOGIA DO NORTE DO BRASIL",
    sigla: "FACETEN",
    estado: "RR",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EMPRESARIAIS",
    sigla: "FACEMP",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EXATAS E HUMANAS DA CAMPANHA",
    sigla: "FCCP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS EXATAS E TECNOLÓGICAS SANTO AGOSTINHO - FACET",
    sigla: "FACET",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS ALVES FORTES",
    sigla: "FACE - ALFOR",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS BARÃO DE JUNDIAÍ",
    sigla: "FCG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS DA BAHIA",
    sigla: "UNICENID",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS DE MANHUAÇU",
    sigla: "FACIG",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS DE SÃO GOTARDO",
    sigla: "CESG",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS E EMPREENDEDORISMO - FACIGE",
    sigla: "FACIGE",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS GERENCIAIS PADRE ARNALDO JANSSEN",
    sigla: "FAJANSSEN",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS DE CRUZEIRO",
    sigla: "FACIC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS DE OLINDA",
    sigla: "FACHO",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS DE PERNAMBUCO",
    sigla: "FCHPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS DO SERTÃO CENTRAL",
    sigla: "FACHUSC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS DO VALE DO RIO GRANDE",
    sigla: "FCHVRG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS E BIOLÓGICAS E DA SAÚDE",
    sigla: "FCHBS",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS E EXATAS DO SERTÃO DO SÃO FRANCISCO",
    sigla: "FACESF",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS APLICADAS DO CABO DE SANTO AGOSTINHO",
    sigla: "FACHUCA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS DE ARARIPINA",
    sigla: "FACISA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS E SOCIAIS DE IGARASSU",
    sigla: "FACIG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS ECONÔMICAS E DA SAÚDE DE ARAGUAÍNA",
    sigla: "FAHESA / ITPAC",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS ESUDA",
    sigla: "FCHE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS HUMANAS EXATAS E LETRAS DE RONDÔNIA",
    sigla: "FARO",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS DE ALAGOAS",
    sigla: "FCJAL",
    estado: "AL",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS DE PARAÍSO DO TOCANTINS",
    sigla: "FCJP",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS DE SANTOS DUMONT",
    sigla: "FCJSD",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS E GERENCIAIS DE GARÇA",
    sigla: "FAEG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS APLICADAS DE PRIMAVERA DO LESTE",
    sigla: "FCJSA",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS APLICADAS DO ARAGUAIA",
    sigla: "FACULDADES CATHEDRAL",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS E SOCIAIS DE MACEIÓ",
    sigla: "FAMA",
    estado: "AL",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS JURÍDICAS PROFESSOR ALBERTO DEODATO",
    sigla: "FCJPAD",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS DA SANTA CASA SÃO PAULO",
    sigla: "FCMSCSP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS DE CAMPINA GRANDE",
    sigla: "FCM",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS DE MINAS GERAIS",
    sigla: "FCMMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS DE PERNAMBUCO",
    sigla: "FCM",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS E DA SAÚDE DE JUIZ DE FORA",
    sigla: "FCMS/JF",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS MÉDICAS E PARAMÉDICAS FLUMINENSE",
    sigla: "SEFLU",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SAÚDE EXATAS E JURÍDICAS DE TERESINA",
    sigla: "FACULDADE CEUT",
    estado: "PI",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DO SUL DE MINAS",
    sigla: "FACESM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS DO VALE DO SÃO LOURENÇO",
    sigla: "EDUVALE",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS E DE TECNOLOGIAS DE AGUA BOA",
    sigla: "FACESA",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS APLICADAS",
    sigla: "FACISA",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS DE FLORIANÓPOLIS",
    sigla: "FCSF",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS DE GUARANTÃ DO NORTE",
    sigla: "FCSGN",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS DOS PALMARES",
    sigla: "FACIP",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS E AGRÁRIAS DE ITAPEVA",
    sigla: "FAIT",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS E HUMANAS SOBRAL PINTO",
    sigla: "FAIESP",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS SOCIAIS E TECNOLÓGICAS",
    sigla: "FACITEC",
    estado: "DF",
  },
  {
    nome: "FACULDADE DE CIÊNCIAS TECNOLÓGICAS DE FORTALEZA",
    sigla: "FCTFOR",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE COLIDER",
    sigla: "FACIDER",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE COMPUTAÇÃO DE MONTES CLAROS",
    sigla: "FACOMP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE COMPUTAÇÃO E INFORMÁTICA DA FUNDAÇÃO ARMANDO ALVARES PENTEADO",
    sigla: "FCI-FAAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE COMUNICAÇÃO E MARKETING DA - FUNDAÇÃO ARMANDO ÁLVARES PENTEADO",
    sigla: "FACOM-FAAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE COMUNICAÇÃO E TURISMO DE OLINDA",
    sigla: "FACOTTUR",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE COMUNICAÇÃO PITÁGORAS UNIDADE GUARAPARI",
    sigla: "PIT GUARAPARI",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE COMUNICAÇÃO SOCIAL DE PASSOS",
    sigla: "FACOMP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DESENVOLVIMENTO DO RIO GRANDE DO SUL",
    sigla: "FADERGS",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE DESENVOLVIMENTO E INTEGRAÇÃO REGIONAL",
    sigla: "FADIRE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE DESENVOLVIMENTO SUSTENTÁVEL DE CRUZEIRO DO SUL",
    sigla: "IEVAL",
    estado: "AC",
  },
  {
    nome: "FACULDADE DE DIREITO DE CACHOEIRO DO ITAPEMIRIM",
    sigla: "FDCI",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE DIREITO DE CARUARU",
    sigla: "FADICA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE DIREITO DE CONSELHEIRO LAFAIETE",
    sigla: "FDCL",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO DE FRANCA",
    sigla: "FDF",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE DIREITO DE GARANHUNS",
    sigla: "FDG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE DIREITO DE IPATINGA",
    sigla: "FADIPA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO DE ITÚ",
    sigla: "FADITU",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE DIREITO DE SANTA MARIA",
    sigla: "FADISMA",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE DIREITO DE SOROCABA",
    sigla: "FADI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE DIREITO DE SÃO BERNARDO DO CAMPO",
    sigla: "FDSBC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE DIREITO DE TANGARÁ DA SERRA",
    sigla: "UNIC",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE DIREITO DE VARGINHA - FADIVA",
    sigla: "FADIVA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO DO SUL DE MINAS",
    sigla: "FDSM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO DO VALE DO RIO DOCE",
    sigla: "FADIVALE",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO E CIÊNCIAS SOCIAIS DO LESTE DE MINAS - FADILESTE",
    sigla: "FADILESTE",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO FRANCISCO BELTRÃO",
    sigla: "CESUL",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE DIREITO MILTON CAMPOS",
    sigla: "FDMC",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO PADRE ARNALDO JANSSEN",
    sigla: "FAJANSSEN",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE DIREITO UNIDADE GUARAPARI",
    sigla: "FADIG",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE DUQUE DE CAXIAS",
    sigla: "FDC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ECONOMIA E FINANÇAS DO RIO DE JANEIRO",
    sigla: "FEFRJ",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ECONOMIA E FINANÇAS IBMEC",
    sigla: "FACULDADES IBMEC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ECONOMIA E PROCESSAMENTO DE DADOS DE FOZ DO IGUAÇU",
    sigla: "FEPI",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO ADMINISTRAÇÃO E TECNOLOGIA DE IBAITI",
    sigla: "FEATI",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO CIÊNCIAS E ARTES DOM BOSCO DE MONTE APRAZÍVEL",
    sigla: "FAECA DOM BOSCO",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO CIÊNCIAS E LETRAS DE PARAÍSO",
    sigla: "FECIPAR",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE ASSIS",
    sigla: "FAEDA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE BACABAL - FEBAC",
    sigla: "FEBAC",
    estado: "MA",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE BOM DESPACHO",
    sigla: "FACEB",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE COLORADO DO OESTE",
    sigla: "FAEC",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE COSTA RICA",
    sigla: "FECRA",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE GUARATINGUETÁ",
    sigla: "FACEG",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE JARU",
    sigla: "UNICENTRO",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE NOVA ANDRADINA",
    sigla: "FENA",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO DE PORTO VELHO",
    sigla: "UNIRON",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E CIÊNCIAS GERENCIAIS DE SÃO PAULO",
    sigla: "FECG-SP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E CIÊNCIAS HUMANAS DE ANICUNS",
    sigla: "FECHA",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E CULTURA DE VILHENA",
    sigla: "FAEV/UNESC",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E ESTUDOS SOCIAIS DE GOVERNADOR VALADARES",
    sigla: "FUNEES G. Valadares",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E ESTUDOS SOCIAIS DE UBERLÂNDIA",
    sigla: "FUNEES Uberlândia",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO E MEIO AMBIENTE",
    sigla: "FAEMA",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO FÍSICA DA ASSOCIAÇÃO CRISTÃ DE MOÇOS DE SOROCABA",
    sigla: "FEFISO",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO FÍSICA DE BARRA BONITA",
    sigla: "FAEFI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO REGIONAL SERRANA",
    sigla: "FUNPAC",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO SUPERIOR DE TIMBAÚBA",
    sigla: "FAEST",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO SUPERIOR DO PARANÁ",
    sigla: "FESPPR",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO SÃO FRANCISCO",
    sigla: "FAESF",
    estado: "MA",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO SÃO LUÍS",
    sigla: "FESL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO TECNOLÓGICA DO ESTADO DO RIO DE JANEIRO",
    sigla: "FAETERJ PARACAMBI",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE EDUCAÇÃO",
    sigla: "ISECUB",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM DE BELO JARDIM",
    sigla: "FAEB",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM DE PASSOS",
    sigla: "FAENPA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM E MEDICINA NOVA ESPERANÇA DE MOSSORÓ",
    sigla: "Facene",
    estado: "RN",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM LUIZA DE MARILLAC",
    sigla: "FELM",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM NOSSA SENHORA DAS GRAÇAS",
    sigla: "FENSG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM NOVA ESPERANÇA",
    sigla: "FACENE",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE ENFERMAGEM SÃO VICENTE DE PAULA",
    sigla: "FESVIP",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE ENGENHARIA DE MINAS GERAIS",
    sigla: "FEMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ENGENHARIA DE PASSOS",
    sigla: "FEP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ENGENHARIA DE RESENDE",
    sigla: "FER",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ENGENHARIA DE SOROCABA",
    sigla: "FACENS",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ENGENHARIA SOUZA MARQUES",
    sigla: "FESM",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE ENGENHARIA SÃO PAULO",
    sigla: "FESP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ENSINO E CULTURA DO CEARÁ",
    sigla: "FAECE",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DA AMAZÔNIA",
    sigla: "FESAM",
    estado: "AP",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DA CIDADE DE FEIRA DE SANTANA",
    sigla: "FAESF/UNEF",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DA PARAÍBA",
    sigla: "FESP",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DE FLORIANO",
    sigla: "FAESF",
    estado: "PI",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DE MARECHAL CÂNDIDO RONDON",
    sigla: "ISEPE RONDON",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DE SÃO MIGUEL DO IGUAÇU",
    sigla: "FAESI",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR DO INTERIOR PAULISTA",
    sigla: "FAIP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR E FORMAÇÃO INTEGRAL",
    sigla: "FAEF",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ENSINO SUPERIOR SANTA BARBARA",
    sigla: "FAESB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ENSINO TECNOLÓGICO DO ESTADO DO PARÁ",
    sigla: "FACETE",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE ESTUDOS ADMINISTRATIVOS DE MINAS GERAIS",
    sigla: "FEAD",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ESTUDOS AVANÇADOS DO PARÁ",
    sigla: "FEAPA",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE ESTUDOS SOCIAIS APLICADOS DE VIANA",
    sigla: "FESAV",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE ESTUDOS SOCIAIS DO ESPÍRITO SANTO",
    sigla: "PIO XII",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE ESTUDOS SUPERIORES DE MINAS GERAIS",
    sigla: "FEAD",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE EXCELÊNCIA DO RIO GRANDE DO NORTE",
    sigla: "Fatern Gama Filho",
    estado: "RN",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE ALEGRE",
    sigla: "FAFIA",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE CARUARU",
    sigla: "FAFICA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE IBITINGA",
    sigla: "FAIBI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DE SÃO JOSÉ DO RIO PARDO",
    sigla: "FFCL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS NOSSA SENHORA APARECIDA",
    sigla: "FNSA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS SOUZA MARQUES",
    sigla: "FFCLSM",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE FILOSOFIA DE PASSOS",
    sigla: "FAFIPA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE FILOSOFIA E CIÊNCIAS HUMANAS DE GOIATUBA",
    sigla: "FAFICH",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE FILOSOFIA E TEOLOGIA PAULO VI",
    sigla: "FFTP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE FILOSOFIA SANTA DOROTEIA",
    sigla: "FFSD",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DA MATA SUL",
    sigla: "FAMASUL",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE AFOGADOS DA INGAZEIRA",
    sigla: "FAFOPAI",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE ARARIPINA",
    sigla: "FAFOPA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE BELO JARDIM",
    sigla: "FABEJA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE GOIANA",
    sigla: "FFPG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE NAZARÉ DA MATA",
    sigla: "FFPNM",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE PETROLINA",
    sigla: "Faculdade de Formação de Professores de Petrolina",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORMAÇÃO DE PROFESSORES DE SERRA TALHADA",
    sigla: "FAFOPST",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE FORTALEZA",
    sigla: "FAFOR",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE GETÚLIO VARGAS",
    sigla: "FACULDADE IDEAU",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE GOIÂNIA - UNIDADE 1",
    sigla: "FAG",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE GUANAMBI",
    sigla: "FG",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE ILHA SOLTEIRA",
    sigla: "FAISA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE IMPERATRIZ",
    sigla: "FACIMP",
    estado: "MA",
  },
  {
    nome: "FACULDADE DE INFORMÁTICA DE OURO PRETO DO OESTE",
    sigla: "FIOURO",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE INFORMÁTICA DE PASSOS",
    sigla: "FIP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE INFORMÁTICA DO RECIFE",
    sigla: "FACIR",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE INFORMÁTICA LEMOS DE CASTRO",
    sigla: "FILC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE INHUMAS - FAC-MAIS",
    sigla: "FACMAIS",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE INTEGRAÇÃO DO SERTÃO",
    sigla: "FIS",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE IPORÁ",
    sigla: "FAI",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE ITAITUBA",
    sigla: "FAI",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE ITAPECERICA DA SERRA",
    sigla: "FIT",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ITAPIRANGA",
    sigla: "SEI/FAI",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE ITÁPOLIS - FACITA",
    sigla: "FACITA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE JABOTICABAL",
    sigla: "FAJAB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE JAGUARIÚNA",
    sigla: "FAJ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE JANDAIA DO SUL",
    sigla: "FAFIJAN",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE JOSÉ BONIFÁCIO",
    sigla: "FJB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE JUAZEIRO DO NORTE",
    sigla: "FJN",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE JUNQUEIRÓPOLIS",
    sigla: "ISEJ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE JUSSARA",
    sigla: "FAJ",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE MACAPÁ",
    sigla: "FAMA",
    estado: "AP",
  },
  {
    nome: "FACULDADE DE MEDICINA DE BARBACENA",
    sigla: "FUNJOB",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE MEDICINA DE CAMPOS",
    sigla: "FMC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE MEDICINA DE ITAJUBÁ",
    sigla: "FMIT",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE MEDICINA DE JUAZEIRO DO NORTE",
    sigla: "FMJ",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE MEDICINA DE JUNDIAÍ",
    sigla: "FMJ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MEDICINA DE MARÍLIA",
    sigla: "FAMEMA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MEDICINA DE PETRÓPOLIS",
    sigla: "FMP",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE MEDICINA DE SÃO JOSÉ DO RIO PRETO",
    sigla: "FAMERP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MEDICINA DO ABC",
    sigla: "FMABC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MINAS",
    sigla: "FAMINAS",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE MIRANDÓPOLIS",
    sigla: "FAM",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MODA DE PASSOS",
    sigla: "FAMOPA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE MONTE ALTO",
    sigla: "FMA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE MÚSICA DO ESPÍRITO SANTO",
    sigla: "FAMES",
    estado: "ES",
  },
  {
    nome: "FACULDADE DE NANUQUE",
    sigla: "FANAN",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE NATAL",
    sigla: "FAL",
    estado: "RN",
  },
  {
    nome: "FACULDADE DE NOVA SERRANA",
    sigla: "FANS",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE NUTRIÇÃO DA FUNDAÇÃO DE ENSINO SUPERIOR DE PASSOS",
    sigla: "FANUTRI",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE ODONTOLOGIA DE CARUARU",
    sigla: "FOC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ODONTOLOGIA DE MANAUS",
    sigla: "Fom",
    estado: "AM",
  },
  {
    nome: "FACULDADE DE ODONTOLOGIA DE PERNAMBUCO",
    sigla: "FOP",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ODONTOLOGIA DO RECIFE",
    sigla: "FOR",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ODONTOLOGIA E CENTRO DE PESQUISAS ODONTOLÓGICAS SÃO LEOPOLDO MANDIC",
    sigla: "SLMANDIC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE OLINDA",
    sigla: "FOCCA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE ORLÂNDIA",
    sigla: "FAO",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE PALMAS",
    sigla: "FAPAL",
    estado: "TO",
  },
  {
    nome: "FACULDADE DE PATO BRANCO",
    sigla: "FADEP",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE PAULÍNIA",
    sigla: "FACP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE PEDAGOGIA",
    sigla: "ANAEC",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE PIMENTA BUENO",
    sigla: "FAP",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE PINDAMONHANGABA",
    sigla: "FAPI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE PONTA PORÃ",
    sigla: "FAP",
    estado: "MS",
  },
  {
    nome: "FACULDADE DE PORTO VELHO",
    sigla: "FIP",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE PRESIDENTE EPITÁCIO - FAPE",
    sigla: "FAPE",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE PRESIDENTE VENCESLAU",
    sigla: "FAPREV",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE PRIMAVERA",
    sigla: "CESPRI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE QUATRO MARCOS",
    sigla: "FQM",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE REABILITAÇÃO DA ASCE",
    sigla: "FRASCE",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE REALEZA",
    sigla: "CESREAL",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE RIBEIRÃO PRETO",
    sigla: "AFARP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE ROLIM DE MOURA",
    sigla: "FAROL",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE RONDÔNIA",
    sigla: "FARO",
    estado: "RO",
  },
  {
    nome: "FACULDADE DE ROSEIRA",
    sigla: "FARO",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE SABARÁ",
    sigla: "SOECS",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE SAÚDE CIÊNCIAS HUMANAS E TECNOLÓGICAS DO PIAUÍ",
    sigla: "Novafapi",
    estado: "PI",
  },
  {
    nome: "FACULDADE DE SAÚDE DE SÃO PAULO",
    sigla: "FASSP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE SAÚDE E DESENVOLVIMENTO HUMANO SANTO AGOSTINHO",
    sigla: "FS",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE SAÚDE IBITURUNA",
    sigla: "FASI",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE SERGIPE",
    sigla: "FaSe",
    estado: "SE",
  },
  {
    nome: "FACULDADE DE SERVIÇO SOCIAL DE PASSOS",
    sigla: "FASESP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE SORRISO",
    sigla: "FAIS",
    estado: "MT",
  },
  {
    nome: "FACULDADE DE SÃO BENTO DO RIO DE JANEIRO",
    sigla: "FSB/RJ",
    estado: "RJ",
  },
  {
    nome: "FACULDADE DE SÃO JOSÉ DOS CAMPOS",
    sigla: "BILAC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE SÃO LOURENÇO",
    sigla: "FASAMA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE SÃO ROQUE",
    sigla: "FAEV",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE SÃO VICENTE",
    sigla: "FSV",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TALENTOS HUMANOS",
    sigla: "FACTHUS",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE TAQUARITINGA",
    sigla: "FTGA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA APOENA",
    sigla: "FTA",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA BANDEIRANTES",
    sigla: "BANDTEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA CENTEC",
    sigla: "CENTEC",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DA PARAÍBA",
    sigla: "FATECPB",
    estado: "PB",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE BOTUCATU",
    sigla: "FATEC BT",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE CARAPICUIBA",
    sigla: "FATEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE GUARATINGUETÁ",
    sigla: "FATEC GT",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE ITAPETININGA - PROF.ANTÔNIO BELIZANDRO BARBOSA REZENDE",
    sigla: "Fatec - Itapetininga",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE ITAQUAQUECETUBA",
    sigla: "Fatec Itaqua",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE JACAREÍ",
    sigla: "ETEP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE JUNDIAÍ",
    sigla: "FATEC/JD",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE MINAS GERAIS",
    sigla: "FATEMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE MOGI DAS CRUZES",
    sigla: "FATEC-MC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE PIRACICABA",
    sigla: "Fatec Piracicaba",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE PORTO ALEGRE",
    sigla: "FAQI",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE SÃO BERNARDO DO CAMPO",
    sigla: "FATEC-SB",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE SÃO JOSÉ DO RIO PRETO",
    sigla: "FATECRP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE SÃO JOSÉ DOS CAMPOS",
    sigla: "ETEP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE SÃO SEBASTIÃO",
    sigla: "Fatec SS",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE TAQUARITINGA",
    sigla: "FATEC/TQ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE TATUÍ - PROF. WILSON ROBERTO RIBEIRO DE CAMARGO",
    sigla: "FATEC TATUÍ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DE VALENÇA",
    sigla: "FACTIVA",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DO COMÉRCIO",
    sigla: "FATEC-COMERCIO",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DO ESTADO DE SÃO PAULO",
    sigla: "FATEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DO IPIRANGA",
    sigla: "FATECIPI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DO NORDESTE",
    sigla: "FATENE",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DO PIAUÍ",
    sigla: "FATEPI",
    estado: "PI",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA DR. THOMAZ NOVELINO",
    sigla: "FATEC Franca",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E CIENCIAS DO NORTE DO PARANÁ",
    sigla: "FATECIE",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E CIÊNCIAS DE PERNAMBUCO",
    sigla: "FATEC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E CIÊNCIAS",
    sigla: "FTC",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E CIÊNCIAS",
    sigla: "FTCEAD",
    estado: "SE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E GESTÃO",
    sigla: "FATEG",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA E NEGÓCIOS CARLOS DRUMMOND DE ANDRADE",
    sigla: "FTNCDA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA EGÍDIO JOSÉ DA SILVA",
    sigla: "FATEGIDIO",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA EM HOTELARIA GASTRONOMIA E TURISMO DE SÃO PAULO",
    sigla: "HOTEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA EMPRESARIAL",
    sigla: "FTEBA",
    estado: "BA",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA ESTUDANTE RAFAEL ALMEIDA CAMARINHA - MARILIA",
    sigla: "Fatec Marilia",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA EVOLUÇÃO",
    sigla: "FECET",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA FAMA",
    sigla: "FAMA",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA FRANCISCO MORATO",
    sigla: "FFRAMO",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA GESTÃO & MARKETING",
    sigla: "IBGM / FGM",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA IBRATEC",
    sigla: "UNIBRATEC",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA IBTA CAMPINAS",
    sigla: "IBTA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA INESUL DO PARANÁ",
    sigla: "FIPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA INFORMÁTICA",
    sigla: "FATI",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA INTENSIVA",
    sigla: "FATECI",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA INTERNACIONAL DE CURITIBA",
    sigla: "FATEC Internacional",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA LA SALLE - ESTRELA",
    sigla: "FACSALLE",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA LOURENÇO FILHO",
    sigla: "FATEC FLF",
    estado: "CE",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA OSWALDO CRUZ",
    sigla: "FATEC OSWALDO CRUZ",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA PEDRO ROGÉRIO GARCIA",
    sigla: "FATTEP",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA PENTÁGONO",
    sigla: "FATEP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA PROF. LUIZ ROSA",
    sigla: "FATEC Luiz Rosa",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA RUBENS LARA",
    sigla: "FATEC-BS",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SAINT PASTOUS",
    sigla: "FSP",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAC BLUMENAU",
    sigla: "SENAC",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAC FLORIANÓPOLIS",
    sigla: "SENAC FLORIANÓPOLIS",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAC SÃO MIGUEL DO OESTE",
    sigla: "5133",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAI BELO HORIZONTE",
    sigla: "FATEC SENAI BH",
    estado: "MG",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAI CHAPECÓ",
    sigla: "SENAI",
    estado: "SC",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAI DE DESENVOLVIMENTO GERENCIAL",
    sigla: "FATESG",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAI ROBERTO MANGE",
    sigla: "FATEC SENAI RM",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA SENAI ÍTALO BOLOGNA",
    sigla: "FATECIB",
    estado: "GO",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA TECBRASIL",
    sigla: "FTEC",
    estado: "RS",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA TECMED",
    sigla: "TECMED",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA TERMOMECANICA",
    sigla: "FTT",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA ZONA LESTE",
    sigla: "FATEC-ZL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECNOLOGIA ÁLVARES DE AZEVEDO",
    sigla: "FAATESP",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TECONOLOGIA DA ZONA SUL",
    sigla: "FATEC ZONASUL",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TELÊMACO BORBA",
    sigla: "FATEB",
    estado: "PR",
  },
  {
    nome: "FACULDADE DE TEOLOGIA E CIÊNCIAS",
    sigla: "FATEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE TEOLOGIA FILOSOFIA E CIÊNCIAS HUMANAS GAMALIEL",
    sigla: "FATEFIG",
    estado: "PA",
  },
  {
    nome: "FACULDADE DE TEOLOGIA INTEGRADA",
    sigla: "FATIN",
    estado: "PE",
  },
  {
    nome: "FACULDADE DE TUPI PAULISTA",
    sigla: "CESTUPI",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE VINHEDO",
    sigla: "FV",
    estado: "SP",
  },
  {
    nome: "FACULDADE DE VIÇOSA",
    sigla: "FDV",
    estado: "MG",
  },
  {
    nome: "FACULDADE DECISION DE NEGÓCIOS",
    sigla: "FACULDADE DECISION",
    estado: "RS",
  },
  {
    nome: "FACULDADE DECISÃO",
    sigla: "FADE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DEHONIANA",
    sigla: "DEHONIANA",
    estado: "SP",
  },
  {
    nome: "FACULDADE DEL REY",
    sigla: "FDR",
    estado: "MG",
  },
  {
    nome: "FACULDADE DELTA",
    sigla: "FACDELTA",
    estado: "BA",
  },
  {
    nome: "FACULDADE DIADEMA",
    sigla: "FAD",
    estado: "SP",
  },
  {
    nome: "FACULDADE DINÂMICA DO VALE DO PIRANGA",
    sigla: "FADIP",
    estado: "MG",
  },
  {
    nome: "FACULDADE DIOCESANA SÃO JOSÉ",
    sigla: "FADISI",
    estado: "AC",
  },
  {
    nome: "FACULDADE DIVINÓPOLIS",
    sigla: "FACED",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO ACRE",
    sigla: "FAC",
    estado: "AC",
  },
  {
    nome: "FACULDADE DO AGRESTE DE PERNAMBUCO",
    sigla: "FAAPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE DO AMAZONAS",
    sigla: "Iaes",
    estado: "AM",
  },
  {
    nome: "FACULDADE DO BAIXO PARNAÍBA",
    sigla: "FAP",
    estado: "MA",
  },
  {
    nome: "FACULDADE DO BICO DO PAPAGAIO",
    sigla: "FABIC",
    estado: "TO",
  },
  {
    nome: "FACULDADE DO CENTRO EDUCACIONAL MINEIRO - FACEM",
    sigla: "FACEM-BH",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO CENTRO LESTE",
    sigla: "UCL",
    estado: "ES",
  },
  {
    nome: "FACULDADE DO CLUBE NÁUTICO MOGIANO",
    sigla: "FCNM",
    estado: "SP",
  },
  {
    nome: "FACULDADE DO DESCOBRIMENTO",
    sigla: "FACDESCO",
    estado: "BA",
  },
  {
    nome: "FACULDADE DO ESTADO DO MARANHÃO",
    sigla: "FACEM",
    estado: "MA",
  },
  {
    nome: "FACULDADE DO FUTURO",
    sigla: "FAF",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO GUARUJÁ",
    sigla: "FAGU",
    estado: "SP",
  },
  {
    nome: "FACULDADE DO INSTITUTO BRASIL",
    sigla: "FIBRA",
    estado: "GO",
  },
  {
    nome: "FACULDADE DO INSTITUTO NACIONAL DE PÓS-GRADUAÇÃO DE SÃO JOSÉ DOS CAMPOS",
    sigla: "FACULDADE INPG - SJC",
    estado: "SP",
  },
  {
    nome: "FACULDADE DO LITORAL CATARINENSE",
    sigla: "FLC",
    estado: "SC",
  },
  {
    nome: "FACULDADE DO LITORAL PARANAENSE",
    sigla: "FLP",
    estado: "PR",
  },
  {
    nome: "FACULDADE DO LITORAL SUL PAULISTA",
    sigla: "FALS",
    estado: "SP",
  },
  {
    nome: "FACULDADE DO MEIO AMBIENTE E DE TECNOLOGIA DE NEGOCIOS",
    sigla: "FAMATEC",
    estado: "DF",
  },
  {
    nome: "FACULDADE DO NOROESTE DE MINAS",
    sigla: "FINOM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO NOROESTE PARANAENSE",
    sigla: "FANP",
    estado: "PR",
  },
  {
    nome: "FACULDADE DO NORTE GOIANO",
    sigla: "FNG",
    estado: "GO",
  },
  {
    nome: "FACULDADE DO NORTE NOVO DE APUCARANA",
    sigla: "FACNOPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE DO NORTE PIONEIRO",
    sigla: "FANORPI",
    estado: "PR",
  },
  {
    nome: "FACULDADE DO PANTANAL MATOGROSSENSE",
    sigla: "FAPAN",
    estado: "MT",
  },
  {
    nome: "FACULDADE DO SUDESTE GOIANO",
    sigla: "FASUG",
    estado: "GO",
  },
  {
    nome: "FACULDADE DO SUDESTE MINEIRO",
    sigla: "FACSUM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO SUL DA BAHIA",
    sigla: "FASB",
    estado: "BA",
  },
  {
    nome: "FACULDADE DO SUL",
    sigla: "FACSUL",
    estado: "BA",
  },
  {
    nome: "FACULDADE DO TAPAJÓS",
    sigla: "FAT",
    estado: "PA",
  },
  {
    nome: "FACULDADE DO TRABALHO",
    sigla: "FATRA",
    estado: "MG",
  },
  {
    nome: "FACULDADE DO VALE DO IPOJUCA",
    sigla: "FAVIP",
    estado: "PE",
  },
  {
    nome: "FACULDADE DO VALE DO ITAJAÍ MIRIM",
    sigla: "FAVIM",
    estado: "SC",
  },
  {
    nome: "FACULDADE DO VALE DO ITAPECURÚ",
    sigla: "FAI",
    estado: "MA",
  },
  {
    nome: "FACULDADE DOCTUM DE ADMINISTRAÇÃO DA SERRA",
    sigla: "DOCTUM",
    estado: "ES",
  },
  {
    nome: "FACULDADE DOCTUM DE ADMINISTRAÇÃO E EDUCAÇÃO DE VITÓRIA",
    sigla: "DOCTUM",
    estado: "ES",
  },
  {
    nome: "FACULDADE DOCTUM DE CARANGOLA",
    sigla: "DOCTUM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DOCTUM DE DIREITO DA SERRA",
    sigla: "DOCTUM",
    estado: "ES",
  },
  {
    nome: "FACULDADE DOCTUM DE JOÃO MONLEVADE",
    sigla: "DOCTUM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DOCTUM DE JUIZ DE FORA",
    sigla: "DOCTUM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DOCTUM DE MANHUAÇU",
    sigla: "DOCTUM",
    estado: "MG",
  },
  {
    nome: "FACULDADE DOCTUM DE VILA VELHA",
    sigla: "DOCTUM",
    estado: "ES",
  },
  {
    nome: "FACULDADE DOCTUM DE VITÓRIA",
    sigla: "DOCTUM",
    estado: "ES",
  },
  {
    nome: "FACULDADE DOIS DE JULHO",
    sigla: "F2J",
    estado: "BA",
  },
  {
    nome: "FACULDADE DOM ALBERTO",
    sigla: "FDA",
    estado: "RS",
  },
  {
    nome: "FACULDADE DOM BOSCO",
    sigla: "FDB",
    estado: "PR",
  },
  {
    nome: "FACULDADE DOM LUIS DE ORLEANS E BRAGANÇA",
    sigla: "FARRP",
    estado: "BA",
  },
  {
    nome: "FACULDADE DOM PEDRO II DE TECNOLOGIA",
    sigla: "FAB",
    estado: "BA",
  },
  {
    nome: "FACULDADE DOM PEDRO II",
    sigla: "FDPII ",
    estado: "BA",
  },
  {
    nome: "FACULDADE DOS CERRADOS PIAUIENSES",
    sigla: "FCP",
    estado: "PI",
  },
  {
    nome: "FACULDADE DOS GUARARAPES",
    sigla: "FG",
    estado: "PE",
  },
  {
    nome: "FACULDADE DOS IMIGRANTES - FAI",
    sigla: "FAI",
    estado: "RS",
  },
  {
    nome: "FACULDADE DOUTOR FRANCISCO MAEDA",
    sigla: "FAFRAM",
    estado: "SP",
  },
  {
    nome: "FACULDADE DOUTOR LEOCÁDIO JOSÉ CORREIA",
    sigla: "FALEC",
    estado: "PR",
  },
  {
    nome: "FACULDADE ECOAR",
    sigla: "FAECO",
    estado: "RS",
  },
  {
    nome: "FACULDADE EDUCACIONAL DA LAPA",
    sigla: "FAEL",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE ARAPOTI",
    sigla: "FATI",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE COLOMBO",
    sigla: "FAEC",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE CORNÉLIO PROCÓPIO",
    sigla: "FACED",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE DOIS VIZINHOS",
    sigla: "FAED",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE FRANCISCO BELTRÃO",
    sigla: "FEFB",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE MEDIANEIRA",
    sigla: "FACEMED",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCACIONAL DE PONTA GROSSA",
    sigla: "UNIÃO",
    estado: "PR",
  },
  {
    nome: "FACULDADE EDUCAÇÃO FÍSICA DE PASSOS",
    sigla: "FADEF",
    estado: "MG",
  },
  {
    nome: "FACULDADE EDUVALE DE AVARÉ",
    sigla: "EDUVALE",
    estado: "SP",
  },
  {
    nome: "FACULDADE EMPRESARIAL DE CHAPECÓ",
    sigla: "FAEM",
    estado: "SC",
  },
  {
    nome: "FACULDADE ENIAC",
    sigla: "ENIAC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ENTRE RIOS DO PIAUÍ",
    sigla: "FAERPI",
    estado: "PI",
  },
  {
    nome: "FACULDADE EQUIPE",
    sigla: "FAE",
    estado: "RS",
  },
  {
    nome: "FACULDADE ERNESTO RISCALI",
    sigla: "FAER",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESAMC SANTOS",
    sigla: "ESAMC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESAMC SOROCABA",
    sigla: "ESAMC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESAMC UBERLÂNDIA",
    sigla: "ESAMC",
    estado: "MG",
  },
  {
    nome: "FACULDADE ESCOLA PAULISTA DE DIREITO",
    sigla: "FACEPD",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESCRITOR OSMAN DA COSTA LINS",
    sigla: "FACOL",
    estado: "PE",
  },
  {
    nome: "FACULDADE ESPECIALIZADA NA ÁREA DE SAÚDE DO RIO GRANDE DO SUL",
    sigla: "FASURGS",
    estado: "RS",
  },
  {
    nome: "FACULDADE ESPÍRITO SANTENSE",
    sigla: "UNICAPE",
    estado: "ES",
  },
  {
    nome: "FACULDADE ESTADUAL DE CIÊNCIAS E LETRAS DE CAMPO MOURÃO",
    sigla: "FECILCAM",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTADUAL DE CIÊNCIAS ECONÔMICAS DE APUCARANA",
    sigla: "FECEA",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTADUAL DE FILOSOFIA CIÊNCIAS E LETRAS DE PARANAGUÁ",
    sigla: "FAFIPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTADUAL DE FILOSOFIA CIÊNCIAS LETRAS UNIÃO DA VITÓRIA",
    sigla: "FAFIUV",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTAÇÃO",
    sigla: "FAEST",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTÁCIO COTIA",
    sigla: "Estácio FAAC",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESTÁCIO DA AMAZÔNIA",
    sigla: "Estácio Atual",
    estado: "RR",
  },
  {
    nome: "FACULDADE ESTÁCIO DA PARAÍBA",
    sigla: "ESTÁCIO PARAÍBA",
    estado: "PB",
  },
  {
    nome: "FACULDADE ESTÁCIO DE ALAGOAS - ESTÁCIO FAL",
    sigla: "ESTÁCIO FAL",
    estado: "AL",
  },
  {
    nome: "FACULDADE ESTÁCIO DE CURITIBA",
    sigla: "ESTÁCIO CURITIBA",
    estado: "PR",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SANTO ANDRÉ",
    sigla: "ESTÁCIO SANTO ANDRÉ",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÁ DE CAMPO GRANDE",
    sigla: "FESCG",
    estado: "MS",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÁ DE GOIÁS",
    sigla: "FESGO",
    estado: "GO",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÁ DE JUIZ DE FORA",
    sigla: "FESJF",
    estado: "MG",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÁ DE OURINHOS",
    sigla: "FAESO",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÁ DE VILA VELHA",
    sigla: "FESVV",
    estado: "ES",
  },
  {
    nome: "FACULDADE ESTÁCIO DE SÃO LUÍS",
    sigla: "ESTÁCIO SÃO LUÍS",
    estado: "MA",
  },
  {
    nome: "FACULDADE ESTÁCIO DO AMAPÁ - ESTÁCIO FAMAP",
    sigla: "ESTÁCIO FAMAP",
    estado: "AP",
  },
  {
    nome: "FACULDADE ESTÁCIO DO RECIFE - ESTÁCIO FIR",
    sigla: "Estácio FIR",
    estado: "PE",
  },
  {
    nome: "FACULDADE ESTÁCIO EURO- PANAMERICANA DE HUMANIDADES E TECNOLOGIAS - ESTÁCIO EUROPAN",
    sigla: "ESTÁCIO EUROPAN",
    estado: "SP",
  },
  {
    nome: "FACULDADE ESTÁCIO MONTESSORI DE IBIÚNA",
    sigla: "ESTÁCIO FMI",
    estado: "SP",
  },
  {
    nome: "FACULDADE EUCLIDES DA CUNHA",
    sigla: "FAEUC",
    estado: "AC",
  },
  {
    nome: "FACULDADE EUROPÉIA DE ADMINISTRAÇÃO E MARKETING",
    sigla: "FEPAM",
    estado: "PE",
  },
  {
    nome: "FACULDADE EVANGÉLICA DE SALVADOR",
    sigla: "FACESA",
    estado: "BA",
  },
  {
    nome: "FACULDADE EVANGÉLICA DO MEIO NORTE",
    sigla: "FAEME",
    estado: "MA",
  },
  {
    nome: "FACULDADE EVANGÉLICA DO PARANÁ",
    sigla: "FEPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE EVANGÉLICA DO PIAUI",
    sigla: "FAEPI",
    estado: "PI",
  },
  {
    nome: "FACULDADE EVOLUTIVO",
    sigla: "Face",
    estado: "CE",
  },
  {
    nome: "FACULDADE EVOLUÇÃO ALTO OESTE POTIGUAR",
    sigla: "FACEP",
    estado: "RN",
  },
  {
    nome: "FACULDADE EÇA DE QUEIROS",
    sigla: "FACEQ",
    estado: "SP",
  },
  {
    nome: "FACULDADE FACCAT",
    sigla: "FACCAT",
    estado: "SP",
  },
  {
    nome: "FACULDADE FACTUM",
    sigla: "Factum",
    estado: "RS",
  },
  {
    nome: "FACULDADE FAPAN",
    sigla: "FAPAN",
    estado: "SP",
  },
  {
    nome: "FACULDADE FARIAS BRITO",
    sigla: "FFB",
    estado: "CE",
  },
  {
    nome: "FACULDADE FASIPE",
    sigla: "FASIPE",
    estado: "MT",
  },
  {
    nome: "FACULDADE FERNÃO DIAS",
    sigla: "FAFE",
    estado: "SP",
  },
  {
    nome: "FACULDADE FILADÉLFIA",
    sigla: "FAFIL",
    estado: "SP",
  },
  {
    nome: "FACULDADE FLEMING",
    sigla: "SEF",
    estado: "SP",
  },
  {
    nome: "FACULDADE FOZ DO IGUAÇU",
    sigla: "FAFIG",
    estado: "PR",
  },
  {
    nome: "FACULDADE FRASSINETTI DO RECIFE",
    sigla: "FAFIRE",
    estado: "PE",
  },
  {
    nome: "FACULDADE FRUTAL",
    sigla: "FAF",
    estado: "MG",
  },
  {
    nome: "FACULDADE FUCAPE",
    sigla: "FUCAPE",
    estado: "ES",
  },
  {
    nome: "FACULDADE GAMA E SOUZA",
    sigla: "FGS",
    estado: "RJ",
  },
  {
    nome: "FACULDADE GENNARI E PEARTREE",
    sigla: "FGP",
    estado: "SP",
  },
  {
    nome: "FACULDADE GEREMÁRIO DANTAS",
    sigla: "SFNSC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE GLOBAL DE UMUARAMA",
    sigla: "FGU",
    estado: "PR",
  },
  {
    nome: "FACULDADE GUARAPUAVA",
    sigla: "FG",
    estado: "PR",
  },
  {
    nome: "FACULDADE GUARAÍ",
    sigla: "FAG",
    estado: "TO",
  },
  {
    nome: "FACULDADE GUILHERME GUIMBALA",
    sigla: "FGG",
    estado: "SC",
  },
  {
    nome: "FACULDADE HERRERO",
    sigla: "FATEC",
    estado: "PR",
  },
  {
    nome: "FACULDADE HORIZONTES",
    sigla: "FH",
    estado: "SP",
  },
  {
    nome: "FACULDADE HÉLIO ROCHA",
    sigla: "FHR",
    estado: "BA",
  },
  {
    nome: "FACULDADE IBGEN - INSTITUTO BRASILEIRO DE GESTÃO DE NEGÓCIOS",
    sigla: "IBGEN",
    estado: "RS",
  },
  {
    nome: "FACULDADE IBGEN",
    sigla: "IBGEN",
    estado: "RS",
  },
  {
    nome: "FACULDADE ICESP",
    sigla: "ICESP",
    estado: "DF",
  },
  {
    nome: "FACULDADE IDEAL",
    sigla: "FACI",
    estado: "PA",
  },
  {
    nome: "FACULDADE IGUAÇU",
    sigla: "FI",
    estado: "PR",
  },
  {
    nome: "FACULDADE IMPACTA TECNOLOGIA",
    sigla: "FIT",
    estado: "SP",
  },
  {
    nome: "FACULDADE INDEPENDENTE DO NORDESTE",
    sigla: "FAINOR",
    estado: "BA",
  },
  {
    nome: "FACULDADE INED DE RIO CLARO",
    sigla: "CBTA",
    estado: "SP",
  },
  {
    nome: "FACULDADE INEDI",
    sigla: "CESUCA",
    estado: "RS",
  },
  {
    nome: "FACULDADE INESP - INSTITUTO NACIONAL DE ENSINO E PESQUISA",
    sigla: "INESP",
    estado: "SP",
  },
  {
    nome: "FACULDADE INTEGRADA BRASIL AMAZÔNIA",
    sigla: "FIBRA",
    estado: "PA",
  },
  {
    nome: "FACULDADE INTEGRADA DA GRANDE FORTALEZA",
    sigla: "FGF",
    estado: "CE",
  },
  {
    nome: "FACULDADE INTEGRADA DE ARAGUATINS",
    sigla: "FAIARA",
    estado: "TO",
  },
  {
    nome: "FACULDADE INTEGRADA DE ENSINO SUPERIOR DE COLINAS",
    sigla: "FIESC",
    estado: "TO",
  },
  {
    nome: "FACULDADE INTEGRADA DE PERNAMBUCO",
    sigla: "FACIPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE INTEGRADA DE SANTA MARIA",
    sigla: "FISMA",
    estado: "RS",
  },
  {
    nome: "FACULDADE INTEGRADA DO CEARÁ",
    sigla: "Fic",
    estado: "CE",
  },
  {
    nome: "FACULDADE INTEGRADA DO RECIFE",
    sigla: "FIR",
    estado: "PE",
  },
  {
    nome: "FACULDADE INTEGRADA EUCLIDES FERNANDES",
    sigla: "FAJ",
    estado: "BA",
  },
  {
    nome: "FACULDADE INTEGRADA METROPOLITANA DE CAMPINAS",
    sigla: "METROCAMP",
    estado: "SP",
  },
  {
    nome: "FACULDADE INTEGRADA RIO BRANCO",
    sigla: "FIRB",
    estado: "AC",
  },
  {
    nome: "FACULDADE INTEGRADA TIRADENTES",
    sigla: "FITS",
    estado: "AL",
  },
  {
    nome: "FACULDADE INTEGRADO DE CAMPO MOURÃO",
    sigla: "CEI",
    estado: "PR",
  },
  {
    nome: "FACULDADE INTEGRAL CANTAREIRA",
    sigla: "F.I.C.",
    estado: "SP",
  },
  {
    nome: "FACULDADE INTEGRAL DIFERENCIAL",
    sigla: "FACID",
    estado: "PI",
  },
  {
    nome: "FACULDADE INTEGRAÇÃO TIETE",
    sigla: "FIT",
    estado: "SP",
  },
  {
    nome: "FACULDADE INTERAMERICANA DE PORTO VELHO",
    sigla: "UNIRON",
    estado: "RO",
  },
  {
    nome: "FACULDADE INTERATIVA COC",
    sigla: "UniCOC",
    estado: "SE",
  },
  {
    nome: "FACULDADE INTERAÇÃO AMERICANA",
    sigla: "FIA",
    estado: "SP",
  },
  {
    nome: "FACULDADE INTERMUNICIPAL DO NOROESTE DO PARANÁ",
    sigla: "FACINOR",
    estado: "PR",
  },
  {
    nome: "FACULDADE INTERNACIONAL DA PARAÍBA",
    sigla: "FPB",
    estado: "PB",
  },
  {
    nome: "FACULDADE INTERNACIONAL DO DELTA",
    sigla: "INTA",
    estado: "PI",
  },
  {
    nome: "FACULDADE IPEMED DE CIÊNCIA MÉDICAS",
    sigla: "IPEMED",
    estado: "MG",
  },
  {
    nome: "FACULDADE IPIRANGA",
    sigla: "FACIP",
    estado: "PA",
  },
  {
    nome: "FACULDADE ISEIB DE BELO HORIZONTE",
    sigla: "FIBH",
    estado: "MG",
  },
  {
    nome: "FACULDADE ISRAELITA DE CIÊNCIAS DA SAÚDE EINSTEIN",
    sigla: "FICSAE",
    estado: "SP",
  },
  {
    nome: "FACULDADE ITABIRANA DE DESENVOLVIMENTO DAS CIÊNCIAS E TECNOLOGIAS",
    sigla: "FATEC",
    estado: "MG",
  },
  {
    nome: "FACULDADE ITABORAÍ",
    sigla: "OMNI",
    estado: "RJ",
  },
  {
    nome: "FACULDADE ITANHAÉM",
    sigla: "FAITA",
    estado: "SP",
  },
  {
    nome: "FACULDADE ITEANA DE BOTUCATU",
    sigla: "FITB",
    estado: "SP",
  },
  {
    nome: "FACULDADE ITOP",
    sigla: "ITOP",
    estado: "TO",
  },
  {
    nome: "FACULDADE JAGUARIAÍVA",
    sigla: "FAJAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE JANGADA",
    sigla: "FJ",
    estado: "SC",
  },
  {
    nome: "FACULDADE JAPI",
    sigla: "JAPI",
    estado: "SP",
  },
  {
    nome: "FACULDADE JESUÍTA DE FILOSOFIA E TEOLOGIA",
    sigla: "FAJE",
    estado: "MG",
  },
  {
    nome: "FACULDADE JK - ASA NORTE",
    sigla: "CENACAP",
    estado: "DF",
  },
  {
    nome: "FACULDADE JK - BRASÍLIA - UNIDADE PLANO PILOTO",
    sigla: "CENACAP",
    estado: "DF",
  },
  {
    nome: "FACULDADE JK - GUARÁ",
    sigla: "ESAMC BRASÍLIA",
    estado: "DF",
  },
  {
    nome: "FACULDADE JK SOBRADINHO",
    sigla: "FASEP",
    estado: "DF",
  },
  {
    nome: "FACULDADE JOAQUIM NABUCO",
    sigla: "FJN",
    estado: "PE",
  },
  {
    nome: "FACULDADE JOSÉ AUGUSTO VIEIRA",
    sigla: "FJAV",
    estado: "SE",
  },
  {
    nome: "FACULDADE JOSÉ LACERDA FILHO DE CIÊNCIAS APLICADAS",
    sigla: "FAJOLCA",
    estado: "PE",
  },
  {
    nome: "FACULDADE JUVÊNCIO TERRA",
    sigla: "FJT",
    estado: "BA",
  },
  {
    nome: "FACULDADE LA SALLE",
    sigla: "Unisalle",
    estado: "AM",
  },
  {
    nome: "FACULDADE LIONS",
    sigla: "FAC-LIONS",
    estado: "GO",
  },
  {
    nome: "FACULDADE LITERATUS",
    sigla: "Fal",
    estado: "AM",
  },
  {
    nome: "FACULDADE LS",
    sigla: "FACELS",
    estado: "DF",
  },
  {
    nome: "FACULDADE LUCIANO FEIJÃO",
    sigla: "FLF",
    estado: "CE",
  },
  {
    nome: "FACULDADE LUSOBRASILEIRA",
    sigla: "FALUB",
    estado: "PE",
  },
  {
    nome: "FACULDADE LUTERANA RUI BARBOSA",
    sigla: "FALURB",
    estado: "PR",
  },
  {
    nome: "FACULDADE LUTERANA SÃO MARCOS",
    sigla: "FALSM",
    estado: "RS",
  },
  {
    nome: "FACULDADE LÍDER",
    sigla: "FAL",
    estado: "PE",
  },
  {
    nome: "FACULDADE MACHADO DE ASSIS",
    sigla: "FAMA",
    estado: "RJ",
  },
  {
    nome: "FACULDADE MACHADO SOBRINHO",
    sigla: "FMS",
    estado: "MG",
  },
  {
    nome: "FACULDADE MADRE TEREZA",
    sigla: "FAMAT",
    estado: "AP",
  },
  {
    nome: "FACULDADE MADRE THAIS",
    sigla: "FMT",
    estado: "BA",
  },
  {
    nome: "FACULDADE MARANHENSE SÃO JOSÉ DOS COCAIS",
    sigla: "FSJ",
    estado: "MA",
  },
  {
    nome: "FACULDADE MARECHAL RONDON",
    sigla: "FMR",
    estado: "SP",
  },
  {
    nome: "FACULDADE MARIA MILZA",
    sigla: "FAMAM",
    estado: "BA",
  },
  {
    nome: "FACULDADE MARINGÁ",
    sigla: "CESPAR",
    estado: "PR",
  },
  {
    nome: "FACULDADE MARIO SCHENBERG",
    sigla: "FMS",
    estado: "SP",
  },
  {
    nome: "FACULDADE MARISTA",
    sigla: "FMR",
    estado: "PE",
  },
  {
    nome: "FACULDADE MARTHA FALCÃO",
    sigla: "FMF",
    estado: "AM",
  },
  {
    nome: "FACULDADE MATER DEI",
    sigla: "FMD",
    estado: "PR",
  },
  {
    nome: "FACULDADE MAURÍCIO DE NASSAU DE CAMPINA GRANDE",
    sigla: "FMN CG",
    estado: "PB",
  },
  {
    nome: "FACULDADE MAURÍCIO DE NASSAU DE JOÃO PESSOA",
    sigla: "FMN JOÃO PESSOA",
    estado: "PB",
  },
  {
    nome: "FACULDADE MAURÍCIO DE NASSAU DE LAURO FREITAS",
    sigla: "FABAC",
    estado: "BA",
  },
  {
    nome: "FACULDADE MAURÍCIO DE NASSAU",
    sigla: "UNINASSAU",
    estado: "RN",
  },
  {
    nome: "FACULDADE MAUÁ DE BRASÍLIA",
    sigla: "MAUADF",
    estado: "DF",
  },
  {
    nome: "FACULDADE MAX PLANCK",
    sigla: "FMP",
    estado: "SP",
  },
  {
    nome: "FACULDADE MERCÚRIO",
    sigla: "FAMERC",
    estado: "RJ",
  },
  {
    nome: "FACULDADE MERIDIONAL",
    sigla: "IMED",
    estado: "RS",
  },
  {
    nome: "FACULDADE META",
    sigla: "Fameta",
    estado: "AC",
  },
  {
    nome: "FACULDADE METODISTA DE CIÊNCIAS HUMANAS E EXATAS",
    sigla: "METODISTA",
    estado: "SP",
  },
  {
    nome: "FACULDADE METODISTA DE SANTA MARIA",
    sigla: "FAMES",
    estado: "RS",
  },
  {
    nome: "FACULDADE METODISTA GRANBERY",
    sigla: "FMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE METROPOLITANA DA AMAZÔNIA",
    sigla: "FAMAZ",
    estado: "PA",
  },
  {
    nome: "FACULDADE METROPOLITANA DA GRANDE RECIFE",
    sigla: "UNESJ",
    estado: "PE",
  },
  {
    nome: "FACULDADE METROPOLITANA DE CAIEIRAS",
    sigla: "FMC",
    estado: "SP",
  },
  {
    nome: "FACULDADE METROPOLITANA DE CAMAÇARI",
    sigla: "FAMEC ",
    estado: "BA",
  },
  {
    nome: "FACULDADE METROPOLITANA DE FORTALEZA",
    sigla: "Fametro",
    estado: "CE",
  },
  {
    nome: "FACULDADE METROPOLITANA DE GUARAMIRIM",
    sigla: "FAMEG",
    estado: "SC",
  },
  {
    nome: "FACULDADE METROPOLITANA DE MANAUS",
    sigla: "Fametro",
    estado: "AM",
  },
  {
    nome: "FACULDADE METROPOLITANA DE MARINGÁ",
    sigla: "UNIFAMMA",
    estado: "PR",
  },
  {
    nome: "FACULDADE METROPOLITANA DO PLANALTO NORTE",
    sigla: "FAMEPLAN",
    estado: "SC",
  },
  {
    nome: "FACULDADE METROPOLITANA LONDRINENSE",
    sigla: "FML",
    estado: "PR",
  },
  {
    nome: "FACULDADE METROPOLITANA",
    sigla: "UNNESA",
    estado: "RO",
  },
  {
    nome: "FACULDADE MINEIRENSE",
    sigla: "FAMA",
    estado: "GO",
  },
  {
    nome: "FACULDADE MODELO",
    sigla: "FACIMOD",
    estado: "PR",
  },
  {
    nome: "FACULDADE MOGIANA DO ESTADO DE SÃO PAULO",
    sigla: "FAMOESP",
    estado: "SP",
  },
  {
    nome: "FACULDADE MONTEIRO LOBATO",
    sigla: "FATO",
    estado: "RS",
  },
  {
    nome: "FACULDADE MONTES BELOS",
    sigla: "FMB",
    estado: "GO",
  },
  {
    nome: "FACULDADE MONTESSORIANO DE SALVADOR",
    sigla: "FAMA",
    estado: "BA",
  },
  {
    nome: "FACULDADE MORAES JÚNIOR - MACKENZIE RIO",
    sigla: "FMJ - MACKENZIE RIO",
    estado: "RJ",
  },
  {
    nome: "FACULDADE MORUMBI SUL",
    sigla: "FMS",
    estado: "SP",
  },
  {
    nome: "FACULDADE MOZARTEUM DE SÃO PAULO",
    sigla: "FAMOSP",
    estado: "SP",
  },
  {
    nome: "FACULDADE MUNICIPAL DE PALHOÇA",
    sigla: "FMP",
    estado: "SC",
  },
  {
    nome: "FACULDADE MUNICIPAL PROFESSOR FRANCO MONTORO DE MOGI GUAÇU",
    sigla: "FMPFM",
    estado: "SP",
  },
  {
    nome: "FACULDADE MURIALDO",
    sigla: "FAMUR",
    estado: "RS",
  },
  {
    nome: "FACULDADE MÉTODO DE SÃO PAULO",
    sigla: "FAMESP",
    estado: "SP",
  },
  {
    nome: "FACULDADE NACIONAL",
    sigla: "FINAC",
    estado: "ES",
  },
  {
    nome: "FACULDADE NATALENSE DE ENSINO E CULTURA",
    sigla: "Fanec",
    estado: "RN",
  },
  {
    nome: "FACULDADE NATALENSE PARA O DESENVOLVIMENTO DO RIO GRANDE DO NORTE",
    sigla: "FARN",
    estado: "RN",
  },
  {
    nome: "FACULDADE NETWORK",
    sigla: "NWK",
    estado: "SP",
  },
  {
    nome: "FACULDADE NOBRE DE FEIRA DE SANTANA",
    sigla: "FAN",
    estado: "BA",
  },
  {
    nome: "FACULDADE NOROESTE",
    sigla: "FAN",
    estado: "GO",
  },
  {
    nome: "FACULDADE NORTE CAPIXABA DE SAO MATEUS",
    sigla: "MULTIVIX SÃO MATEUS",
    estado: "ES",
  },
  {
    nome: "FACULDADE NORTE PARANAENSE",
    sigla: "UNINORTE",
    estado: "PR",
  },
  {
    nome: "FACULDADE NOSSA CIDADE",
    sigla: "FNC",
    estado: "SP",
  },
  {
    nome: "FACULDADE NOSSA SENHORA APARECIDA",
    sigla: "FANAP",
    estado: "GO",
  },
  {
    nome: "FACULDADE NOSSA SENHORA DE FÁTIMA",
    sigla: "FACULDADE FÁTIMA",
    estado: "RS",
  },
  {
    nome: "FACULDADE NOVA ROMA",
    sigla: "FGV",
    estado: "PE",
  },
  {
    nome: "FACULDADE NOVAUNESC",
    sigla: "NOVAUNESC",
    estado: "PI",
  },
  {
    nome: "FACULDADE NOVO HAMBURGO",
    sigla: "FACULDADE IENH",
    estado: "RS",
  },
  {
    nome: "FACULDADE NOVO MILÊNIO",
    sigla: "FNM",
    estado: "ES",
  },
  {
    nome: "FACULDADE OBOÉ - FACO",
    sigla: "FACO",
    estado: "CE",
  },
  {
    nome: "FACULDADE ORÍGENES LESSA",
    sigla: "FACOL",
    estado: "SP",
  },
  {
    nome: "FACULDADE PADRE ANCHIETA DE VÁRZEA PAULISTA",
    sigla: "ANCHIETA",
    estado: "SP",
  },
  {
    nome: "FACULDADE PADRE JOÃO BAGOZZI",
    sigla: "FACULDADE BAGOZZI",
    estado: "PR",
  },
  {
    nome: "FACULDADE PADRÃO",
    sigla: "FP",
    estado: "GO",
  },
  {
    nome: "FACULDADE PALOTINA",
    sigla: "FAPAS",
    estado: "RS",
  },
  {
    nome: "FACULDADE PAN AMAZÔNICA",
    sigla: "FAPAN",
    estado: "PA",
  },
  {
    nome: "FACULDADE PANAMERICANA DE JIPARANÁ",
    sigla: "UNIJIPA",
    estado: "RO",
  },
  {
    nome: "FACULDADE PARA O DESENVOLVIMENTO DE PERNAMBUCO",
    sigla: "FADEPE",
    estado: "PE",
  },
  {
    nome: "FACULDADE PARAENSE DE ENSINO",
    sigla: "FAPEN",
    estado: "PA",
  },
  {
    nome: "FACULDADE PARANAPANEMA",
    sigla: "FP",
    estado: "PR",
  },
  {
    nome: "FACULDADE PARAÍBANA",
    sigla: "FAP",
    estado: "PB",
  },
  {
    nome: "FACULDADE PARAÍSO DO CEARÁ",
    sigla: "Fap",
    estado: "CE",
  },
  {
    nome: "FACULDADE PARQUE",
    sigla: "FAP",
    estado: "BA",
  },
  {
    nome: "FACULDADE PAULISTA DE ARTES",
    sigla: "FPA",
    estado: "SP",
  },
  {
    nome: "FACULDADE PAULISTA DE EDUCAÇÃO E COMUNICAÇÃO",
    sigla: "FAPEC",
    estado: "SP",
  },
  {
    nome: "FACULDADE PAULISTA DE SERVIÇO SOCIAL",
    sigla: "FAPSS-SP.",
    estado: "SP",
  },
  {
    nome: "FACULDADE PAULUS DE COMUNICAÇÃO E TECNOLOGIA",
    sigla: "FAPCOM",
    estado: "SP",
  },
  {
    nome: "FACULDADE PEDRO LEOPOLDO",
    sigla: "FPL",
    estado: "MG",
  },
  {
    nome: "FACULDADE PENSAR",
    sigla: "FP",
    estado: "BA",
  },
  {
    nome: "FACULDADE PERNAMBUCANA",
    sigla: "Fape",
    estado: "PE",
  },
  {
    nome: "FACULDADE PERUIBE",
    sigla: "FPBE",
    estado: "SP",
  },
  {
    nome: "FACULDADE PHÊNIX DE CIÊNCIAS HUMANAS E SOCIAIS DO BRASIL",
    sigla: "PHENIX",
    estado: "GO",
  },
  {
    nome: "FACULDADE PIAGET",
    sigla: "FACPIAGET",
    estado: "SP",
  },
  {
    nome: "FACULDADE PIAUIENSE DE PROCESSAMENTO DE DADOS",
    sigla: "FPPD",
    estado: "PI",
  },
  {
    nome: "FACULDADE PIAUIENSE",
    sigla: "FAP",
    estado: "PI",
  },
  {
    nome: "FACULDADE PINHALZINHO",
    sigla: "HORUS",
    estado: "SC",
  },
  {
    nome: "FACULDADE PINHEIRO GUIMARÃES",
    sigla: "FAPG",
    estado: "RJ",
  },
  {
    nome: "FACULDADE PIO DÉCIMO",
    sigla: "PIODECIMO",
    estado: "SE",
  },
  {
    nome: "FACULDADE PITÁGORAS DE ADMINISTRAÇÃO SUPERIOR",
    sigla: "FPAS",
    estado: "MG",
  },
  {
    nome: "FACULDADE PITÁGORAS DE BELO HORIZONTE",
    sigla: "FPAS",
    estado: "MG",
  },
  {
    nome: "FACULDADE PITÁGORAS DE BETIM",
    sigla: "PITÁGORAS-BETIM",
    estado: "MG",
  },
  {
    nome: "FACULDADE PITÁGORAS DE DIVINÓPOLIS - FPD",
    sigla: "FPD",
    estado: "MG",
  },
  {
    nome: "FACULDADE PITÁGORAS DE IMPERATRIZ",
    sigla: "FAMA",
    estado: "MA",
  },
  {
    nome: "FACULDADE PITÁGORAS DE IPATINGA",
    sigla: "FPI",
    estado: "MG",
  },
  {
    nome: "FACULDADE PITÁGORAS DE JUNDIAÍ",
    sigla: "PIT JUNDIAÍ",
    estado: "SP",
  },
  {
    nome: "FACULDADE PITÁGORAS DE TEIXEIRA DE FREITAS",
    sigla: "PIT TEIXEIRA",
    estado: "BA",
  },
  {
    nome: "FACULDADE POLITEC",
    sigla: "FAP",
    estado: "SP",
  },
  {
    nome: "FACULDADE POLITÉCNICA DE CAMPINAS",
    sigla: "POLICAMP",
    estado: "SP",
  },
  {
    nome: "FACULDADE POLITÉCNICA DE UBERLÂNDIA",
    sigla: "FPU",
    estado: "MG",
  },
  {
    nome: "FACULDADE PORTO ALGRENSE",
    sigla: "FAPA",
    estado: "RS",
  },
  {
    nome: "FACULDADE PORTO DAS ÁGUAS",
    sigla: "FAPAG",
    estado: "SC",
  },
  {
    nome: "FACULDADE PRESBITERIANA GAMMON",
    sigla: "FAGAMMON",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRESIDENTE ANTÔNIO CARLOS DE AIMORÉS",
    sigla: "FUNEC Aimorés",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRESIDENTE ANTÔNIO CARLOS DE BOM DESPACHO",
    sigla: "FAPACBD",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRESIDENTE ANTÔNIO CARLOS DE GOVERNADOR VALADARES",
    sigla: "FAU G. Valadares",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRESIDENTE ANTÔNIO CARLOS DE RIBEIRÃO DAS NEVES",
    sigla: "FUNEES R. das Neves",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRESIDENTE ANTÔNIO CARLOS DE VÁRZEA DA PALMA",
    sigla: "FEES Várzea da Palma",
    estado: "MG",
  },
  {
    nome: "FACULDADE PRINCESA DO OESTE",
    sigla: "FPO",
    estado: "CE",
  },
  {
    nome: "FACULDADE PROCESSUS",
    sigla: "PFD",
    estado: "DF",
  },
  {
    nome: "FACULDADE PROFESSOR MIGUEL ÂNGELO DA SILVA SANTOS",
    sigla: "FEMASS",
    estado: "RJ",
  },
  {
    nome: "FACULDADE PROJEÇÃO DE CEILÂNDIA",
    sigla: "FACEB",
    estado: "DF",
  },
  {
    nome: "FACULDADE PROJEÇÃO",
    sigla: "FAPRO",
    estado: "DF",
  },
  {
    nome: "FACULDADE PROMOVE DE JANAÚBA",
    sigla: "ISEJAN",
    estado: "MG",
  },
  {
    nome: "FACULDADE PROMOVE DE MINAS GERAIS",
    sigla: "FPMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE PROMOVE DE SETE LAGOAS",
    sigla: "FSLMG",
    estado: "MG",
  },
  {
    nome: "FACULDADE QUIRINÓPOLIS",
    sigla: "FAQUI",
    estado: "GO",
  },
  {
    nome: "FACULDADE RAIMUNDO MARINHO",
    sigla: "FRM",
    estado: "AL",
  },
  {
    nome: "FACULDADE RANCHARIENSE",
    sigla: "FRAN",
    estado: "SP",
  },
  {
    nome: "FACULDADE RAÍZES",
    sigla: "SER",
    estado: "GO",
  },
  {
    nome: "FACULDADE REDENTOR",
    sigla: "FACREDENTOR",
    estado: "RJ",
  },
  {
    nome: "FACULDADE REGES DE DRACENA",
    sigla: "FCGD",
    estado: "SP",
  },
  {
    nome: "FACULDADE REGIONAL DA BAHIA",
    sigla: "FARB",
    estado: "BA",
  },
  {
    nome: "FACULDADE REGIONAL DE ALAGOINHAS",
    sigla: "FARAL",
    estado: "BA",
  },
  {
    nome: "FACULDADE REGIONAL PALMITOS",
    sigla: "FAP",
    estado: "SC",
  },
  {
    nome: "FACULDADE REUNIDA",
    sigla: "FAR",
    estado: "SP",
  },
  {
    nome: "FACULDADE RIO BRANCO",
    sigla: "FARB",
    estado: "AC",
  },
  {
    nome: "FACULDADE RORAIMENSE DE ENSINO SUPERIOR",
    sigla: "FARES",
    estado: "RR",
  },
  {
    nome: "FACULDADE RUY BARBOSA",
    sigla: "FRB",
    estado: "BA",
  },
  {
    nome: "FACULDADE SABERES",
    sigla: "SABERES",
    estado: "ES",
  },
  {
    nome: "FACULDADE SALESIANA DE SANTA TERESA",
    sigla: "FSST",
    estado: "MS",
  },
  {
    nome: "FACULDADE SALESIANA DO NORDESTE",
    sigla: "FASNE",
    estado: "PE",
  },
  {
    nome: "FACULDADE SALESIANA DOM BOSCO",
    sigla: "FSDB",
    estado: "AM",
  },
  {
    nome: "FACULDADE SALESIANA MARIA AUXILIADORA",
    sigla: "FSMA",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SANT'ANA",
    sigla: "IESSA",
    estado: "PR",
  },
  {
    nome: "FACULDADE SANTA AMÉLIA",
    sigla: "SECAL",
    estado: "PR",
  },
  {
    nome: "FACULDADE SANTA CATARINA",
    sigla: "FASC",
    estado: "PE",
  },
  {
    nome: "FACULDADE SANTA CRUZ",
    sigla: "FACRUZ",
    estado: "PE",
  },
  {
    nome: "FACULDADE SANTA EMÍLIA DE RODAT",
    sigla: "FASER",
    estado: "PB",
  },
  {
    nome: "FACULDADE SANTA FÉ",
    sigla: "CESSF",
    estado: "MA",
  },
  {
    nome: "FACULDADE SANTA HELENA",
    sigla: "FASH",
    estado: "PE",
  },
  {
    nome: "FACULDADE SANTA IZILDINHA",
    sigla: "FIESI",
    estado: "SP",
  },
  {
    nome: "FACULDADE SANTA LÚCIA",
    sigla: "FCACSL",
    estado: "SP",
  },
  {
    nome: "FACULDADE SANTA MARCELINA",
    sigla: "FASM",
    estado: "SP",
  },
  {
    nome: "FACULDADE SANTA MARIA",
    sigla: "FSM",
    estado: "PE",
  },
  {
    nome: "FACULDADE SANTA RITA DE CÁSSIA",
    sigla: "UNIFASC",
    estado: "GO",
  },
  {
    nome: "FACULDADE SANTA RITA",
    sigla: "FASAR",
    estado: "SP",
  },
  {
    nome: "FACULDADE SANTA TEREZINHA",
    sigla: "CEST",
    estado: "MA",
  },
  {
    nome: "FACULDADE SANTA TEREZINHA",
    sigla: "FEST",
    estado: "MA",
  },
  {
    nome: "FACULDADE SANTO AGOSTINHO",
    sigla: "FSA",
    estado: "PI",
  },
  {
    nome: "FACULDADE SANTO ANTONIO",
    sigla: "FSA",
    estado: "BA",
  },
  {
    nome: "FACULDADE SANTO ANTÔNIO DE PÁDUA",
    sigla: "FASAP",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SANTO AUGUSTO",
    sigla: "FAISA",
    estado: "RS",
  },
  {
    nome: "FACULDADE SANT´ANNA DE SALTO",
    sigla: "FASAS",
    estado: "SP",
  },
  {
    nome: "FACULDADE SANTÍSSIMO SACRAMENTO",
    sigla: "FSSS",
    estado: "BA",
  },
  {
    nome: "FACULDADE SATC",
    sigla: "FASATC",
    estado: "SC",
  },
  {
    nome: "FACULDADE SEAMA",
    sigla: "SEAMA",
    estado: "AP",
  },
  {
    nome: "FACULDADE SENAC MINAS",
    sigla: "FSM",
    estado: "MG",
  },
  {
    nome: "FACULDADE SENAC PERNAMBUCO",
    sigla: "SENAC",
    estado: "PE",
  },
  {
    nome: "FACULDADE SENAC PORTO ALEGRE - FSPOA",
    sigla: "SENAC/RS",
    estado: "RS",
  },
  {
    nome: "FACULDADE SENAI-CETIQT",
    sigla: "SENAI-CETIQT",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SERGIPANA",
    sigla: "FASER",
    estado: "SE",
  },
  {
    nome: "FACULDADE SERIGY",
    sigla: "FASERGY",
    estado: "SE",
  },
  {
    nome: "FACULDADE SERRA DO CARMO",
    sigla: "FASEC",
    estado: "TO",
  },
  {
    nome: "FACULDADE SERRANA",
    sigla: "FASEP",
    estado: "DF",
  },
  {
    nome: "FACULDADE SINERGIA",
    sigla: "SINERGIA",
    estado: "SC",
  },
  {
    nome: "FACULDADE SINOP",
    sigla: "FASIP",
    estado: "MT",
  },
  {
    nome: "FACULDADE SOCIAL DA BAHIA",
    sigla: "FSBA",
    estado: "BA",
  },
  {
    nome: "FACULDADE SOCIESC DE CURITIBA",
    sigla: "SOCIESC",
    estado: "PR",
  },
  {
    nome: "FACULDADE SOCIESC",
    sigla: "UNICA",
    estado: "SC",
  },
  {
    nome: "FACULDADE SUDAMÉRICA",
    sigla: "SUDAMÉRICA",
    estado: "MG",
  },
  {
    nome: "FACULDADE SUDOESTE PAULISTA",
    sigla: "FSP",
    estado: "SP",
  },
  {
    nome: "FACULDADE SUL BRASIL",
    sigla: "FASUL",
    estado: "PR",
  },
  {
    nome: "FACULDADE SUL FLUMINENSE",
    sigla: "FASF",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SULAMERICANA",
    sigla: "FASAM",
    estado: "GO",
  },
  {
    nome: "FACULDADE SUMARÉ",
    sigla: "ISES",
    estado: "SP",
  },
  {
    nome: "FACULDADE SÃO BENTO DA BAHIA",
    sigla: "FSBB",
    estado: "BA",
  },
  {
    nome: "FACULDADE SÃO CAMILO",
    sigla: "FSC SALVADOR",
    estado: "BA",
  },
  {
    nome: "FACULDADE SÃO FRANCISCO DA PARAÍBA",
    sigla: "FASP",
    estado: "PB",
  },
  {
    nome: "FACULDADE SÃO FRANCISCO DE ASSIS",
    sigla: "UNIFIN",
    estado: "RS",
  },
  {
    nome: "FACULDADE SÃO FRANCISCO DE BARREIRAS - FASB",
    sigla: "FASB",
    estado: "BA",
  },
  {
    nome: "FACULDADE SÃO FRANCISCO DE PIUMHI",
    sigla: "FASPI",
    estado: "MG",
  },
  {
    nome: "FACULDADE SÃO GABRIEL",
    sigla: "FSG",
    estado: "PI",
  },
  {
    nome: "FACULDADE SÃO GERALDO",
    sigla: "FSG",
    estado: "ES",
  },
  {
    nome: "FACULDADE SÃO JOSÉ",
    sigla: "FSJ",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SÃO JUDAS TADEU",
    sigla: "FSJT",
    estado: "RJ",
  },
  {
    nome: "FACULDADE SÃO LUCAS",
    sigla: "FSL",
    estado: "RO",
  },
  {
    nome: "FACULDADE SÃO LUIS DE FRANÇA",
    sigla: "FSLF",
    estado: "SE",
  },
  {
    nome: "FACULDADE SÃO LUÍS",
    sigla: "FSL",
    estado: "MA",
  },
  {
    nome: "FACULDADE SÃO MARCOS",
    sigla: "FASAMAR",
    estado: "TO",
  },
  {
    nome: "FACULDADE SÃO MIGUEL",
    sigla: "FSM",
    estado: "PE",
  },
  {
    nome: "FACULDADE SÃO SALVADOR",
    sigla: "FSSAL ",
    estado: "BA",
  },
  {
    nome: "FACULDADE SÃO SEBASTIÃO",
    sigla: "FASS",
    estado: "SP",
  },
  {
    nome: "FACULDADE SÃO TOMAZ DE AQUINO",
    sigla: "FSTA",
    estado: "BA",
  },
  {
    nome: "FACULDADE TAMANDARÉ",
    sigla: "FAT",
    estado: "GO",
  },
  {
    nome: "FACULDADE TECSOMA",
    sigla: "FATEC",
    estado: "MG",
  },
  {
    nome: "FACULDADE TIJUCUSSU",
    sigla: "TIJUCUSSU",
    estado: "SP",
  },
  {
    nome: "FACULDADE TOBIAS BARRETO",
    sigla: "FTB",
    estado: "SE",
  },
  {
    nome: "FACULDADE TRIÂNGULO MINEIRO",
    sigla: "FTM",
    estado: "MG",
  },
  {
    nome: "FACULDADE TRÊS DE MAIO",
    sigla: "SETREM",
    estado: "RS",
  },
  {
    nome: "FACULDADE TRÊS PONTAS",
    sigla: "FATEP",
    estado: "MG",
  },
  {
    nome: "FACULDADE TÁHIRIH",
    sigla: "FT",
    estado: "AM",
  },
  {
    nome: "FACULDADE UBAENSE OZANAM COELHO",
    sigla: "FAGOC",
    estado: "MG",
  },
  {
    nome: "FACULDADE UBERLANDENSE DE NÚCLEOS INTEGRADOS DE ENSINO SERVIÇO SOCIAL E APRENDIZAGEM",
    sigla: "FAESSA",
    estado: "MG",
  },
  {
    nome: "FACULDADE UBS",
    sigla: "FACULDADE UBS",
    estado: "SP",
  },
  {
    nome: "FACULDADE UNA DE CONTAGEM",
    sigla: "FUNAC",
    estado: "MG",
  },
  {
    nome: "FACULDADE UNIDA DE CAMPINAS",
    sigla: "FACUNICAMPS",
    estado: "GO",
  },
  {
    nome: "FACULDADE UNIDA DE SUZANO",
    sigla: "UNISUZ",
    estado: "SP",
  },
  {
    nome: "FACULDADE UNIGRAN CAPITAL",
    sigla: "UNIGRAN CAPITAL",
    estado: "MS",
  },
  {
    nome: "FACULDADE UNILAGOS",
    sigla: "UNILAGOS",
    estado: "PR",
  },
  {
    nome: "FACULDADE UNIME DE CIÊNCIAS EXATAS E TECNOLÓGICAS",
    sigla: "FCT",
    estado: "BA",
  },
  {
    nome: "FACULDADE UNIME DE CIÊNCIAS SOCIAIS",
    sigla: "FCS",
    estado: "BA",
  },
  {
    nome: "FACULDADE UNISSA DE SARANDI",
    sigla: "UNISSA",
    estado: "PR",
  },
  {
    nome: "FACULDADE UNIÃO ARARUAMA DE ENSINO S/S LTDA.",
    sigla: "FAC-UNILAGOS",
    estado: "RJ",
  },
  {
    nome: "FACULDADE UNIÃO BANDEIRANTE",
    sigla: "FUBSJ",
    estado: "SC",
  },
  {
    nome: "FACULDADE UNIÃO DE CAMPO MOURÃO",
    sigla: "UNICAMPO",
    estado: "PR",
  },
  {
    nome: "FACULDADE UNIÃO DE GOYAZES",
    sigla: "FUG",
    estado: "GO",
  },
  {
    nome: "FACULDADE VALE DO CRICARÉ",
    sigla: "F.V.C.",
    estado: "ES",
  },
  {
    nome: "FACULDADE VALE DO GORUTUBA",
    sigla: "FAVAG",
    estado: "MG",
  },
  {
    nome: "FACULDADE VALE DO JAGUARIBE",
    sigla: "FVJ",
    estado: "CE",
  },
  {
    nome: "FACULDADE VALE DO SALGADO",
    sigla: "FVS",
    estado: "CE",
  },
  {
    nome: "FACULDADE VASCO DA GAMA",
    sigla: "FVG",
    estado: "BA",
  },
  {
    nome: "FACULDADE VENDA NOVA DO IMIGRANTE",
    sigla: "FAVENI",
    estado: "ES",
  },
  {
    nome: "FACULDADE VICENTINA - FAVI",
    sigla: "FAVI",
    estado: "PR",
  },
  {
    nome: "FACULDADE VICTOR HUGO",
    sigla: "FVH",
    estado: "MG",
  },
  {
    nome: "FACULDADE VISCONDE DE CAIRÚ",
    sigla: "FAVIV ",
    estado: "BA",
  },
  {
    nome: "FACULDADE VITORIANA DE TECNOLOGIA",
    sigla: "FAVI",
    estado: "ES",
  },
  {
    nome: "FACULDADE VIZINHANÇA VALE DO IGUAÇU",
    sigla: "VIZIVALI",
    estado: "PR",
  },
  {
    nome: "FACULDADE VÉRTICE",
    sigla: "VÉRTICE",
    estado: "MG",
  },
  {
    nome: "FACULDADE XV DE AGOSTO",
    sigla: "FAQ",
    estado: "SP",
  },
  {
    nome: "FACULDADE ZACARIAS DE GÓES",
    sigla: "FAZAG",
    estado: "BA",
  },
  {
    nome: "FACULDADE ZUMBI DOS PALMARES",
    sigla: "FAZP",
    estado: "SP",
  },
  {
    nome: "FACULDADE ÁREA 1",
    sigla: "ÁREA 1",
    estado: "BA",
  },
  {
    nome: "FACULDADE ÚNICA DE IPATINGA",
    sigla: "FUNIP",
    estado: "MG",
  },
  {
    nome: "FACULDADE ÚNICA DE TIMÓTEO",
    sigla: "FUNIT",
    estado: "MG",
  },
  {
    nome: "FACULDADES ADAMANTINENSES INTEGRADAS",
    sigla: "FAI",
    estado: "SP",
  },
  {
    nome: "FACULDADES ASSOCIADAS DE ARIQUEMES",
    sigla: "FAAR",
    estado: "RO",
  },
  {
    nome: "FACULDADES ASSOCIADAS DE UBERABA",
    sigla: "FAZU",
    estado: "MG",
  },
  {
    nome: "FACULDADES ATIBAIA",
    sigla: "FAAT",
    estado: "SP",
  },
  {
    nome: "FACULDADES CATHEDRAL BARRA DO GARÇAS",
    sigla: "CATHEDRAL",
    estado: "MT",
  },
  {
    nome: "FACULDADES CATHEDRAL",
    sigla: "CATHEDRAL",
    estado: "RR",
  },
  {
    nome: "FACULDADES CEARENSES",
    sigla: "Fac",
    estado: "CE",
  },
  {
    nome: "FACULDADES DA FUNDAÇÃO DE ENSINO DE MOCOCA",
    sigla: "FAFEM",
    estado: "SP",
  },
  {
    nome: "FACULDADES DE CAMPINAS",
    sigla: "FACAMP",
    estado: "SP",
  },
  {
    nome: "FACULDADES DE PINHAIS",
    sigla: "FAPI",
    estado: "PR",
  },
  {
    nome: "FACULDADES DO CENTRO DO PARANÁ",
    sigla: "UCP",
    estado: "PR",
  },
  {
    nome: "FACULDADES EST",
    sigla: "EST",
    estado: "RS",
  },
  {
    nome: "FACULDADES FUTURÃO",
    sigla: "CENTEFF",
    estado: "SC",
  },
  {
    nome: "FACULDADES INTEGRADAS ADVENTISTAS DE MINAS GERAIS",
    sigla: "FADMINAS",
    estado: "MG",
  },
  {
    nome: "FACULDADES INTEGRADAS ANTÔNIO EUFRÁSIO DE TOLEDO DE PRESIDENTE PRUDENTE",
    sigla: "FIAETPP",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS APARÍCIO CARVALHO",
    sigla: "FIMCA",
    estado: "RO",
  },
  {
    nome: "FACULDADES INTEGRADAS ASSOCIAÇÃO DE ENSINO DE SANTA CATARINA",
    sigla: "FASSESC",
    estado: "SC",
  },
  {
    nome: "FACULDADES INTEGRADAS BARROS MELO",
    sigla: "AESO",
    estado: "PE",
  },
  {
    nome: "FACULDADES INTEGRADAS CAMPO-GRANDENSES",
    sigla: "FIC",
    estado: "RJ",
  },
  {
    nome: "FACULDADES INTEGRADAS CAMPOS SALLES",
    sigla: "FICS",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS CLARETIANAS",
    sigla: "FIC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS CORAÇÃO DE JESUS",
    sigla: "FAINC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DA TERRA DE BRASÍLIA",
    sigla: "FTB",
    estado: "DF",
  },
  {
    nome: "FACULDADES INTEGRADAS DA UNIÃO DE ENSINO SUPERIOR CERTO",
    sigla: "UNICERTO",
    estado: "DF",
  },
  {
    nome: "FACULDADES INTEGRADAS DA UNIÃO EDUCACIONAL DO PLANALTO CENTRAL - FACIPLAC",
    sigla: "FACIPLAC",
    estado: "DF",
  },
  {
    nome: "FACULDADES INTEGRADAS DA VITÓRIA DE SANTO ANTÃO",
    sigla: "FAINTVISA",
    estado: "PE",
  },
  {
    nome: "FACULDADES INTEGRADAS DE ARIQUEMES",
    sigla: "FIAR",
    estado: "RO",
  },
  {
    nome: "FACULDADES INTEGRADAS DE BOTUCATU",
    sigla: "UNIFAC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE CACOAL",
    sigla: "UNESC",
    estado: "RO",
  },
  {
    nome: "FACULDADES INTEGRADAS DE CARATINGA",
    sigla: "FIC",
    estado: "MG",
  },
  {
    nome: "FACULDADES INTEGRADAS DE CIÊNCIAS HUMANAS SAÚDE E EDUCAÇÃO DE GUARULHOS",
    sigla: "FG",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE DIAMANTINO",
    sigla: "FID",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS DE FERNANDÓPOLIS",
    sigla: "FIFE",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE ITARARÉ",
    sigla: "FAFIT-FACIC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE JACAREPAGUÁ",
    sigla: "FIJ",
    estado: "RJ",
  },
  {
    nome: "FACULDADES INTEGRADAS DE NAVIRAÍ",
    sigla: "FINAV",
    estado: "MS",
  },
  {
    nome: "FACULDADES INTEGRADAS DE OURINHOS",
    sigla: "FIO",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE PATOS",
    sigla: "FIP",
    estado: "PB",
  },
  {
    nome: "FACULDADES INTEGRADAS DE RIBEIRÃO PIRES",
    sigla: "FIRP",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE RONDONÓPOLIS",
    sigla: "FAIR",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS DE SANTA FÉ DO SUL",
    sigla: "FUNEC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE SÃO CARLOS",
    sigla: "FADISC",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DE TANGARÁ DA SERRA",
    sigla: "FITS",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS DE TAQUARA",
    sigla: "FACCAT",
    estado: "RS",
  },
  {
    nome: "FACULDADES INTEGRADAS DE TRÊS LAGOAS",
    sigla: "AEMS",
    estado: "MS",
  },
  {
    nome: "FACULDADES INTEGRADAS DE VITÓRIA",
    sigla: "FDV",
    estado: "ES",
  },
  {
    nome: "FACULDADES INTEGRADAS DE VÁRZEA GRANDE",
    sigla: "FIAVEC",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS DESEMBARGADOR SÁVIO BRANDÃO",
    sigla: "FAUSB",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS DO BRASIL",
    sigla: "FACBRASIL",
    estado: "PR",
  },
  {
    nome: "FACULDADES INTEGRADAS DO EXTREMO SUL DA BAHIA",
    sigla: "UNESULBAHIA",
    estado: "BA",
  },
  {
    nome: "FACULDADES INTEGRADAS DO OESTE DE MINAS",
    sigla: "FADOM",
    estado: "MG",
  },
  {
    nome: "FACULDADES INTEGRADAS DO TAPAJÓS",
    sigla: "FIT",
    estado: "PA",
  },
  {
    nome: "FACULDADES INTEGRADAS DO VALE DO RIBEIRA",
    sigla: "FIVR",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DOM PEDRO II",
    sigla: "DOMPEDRO",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS DOS CAMPOS GERAIS",
    sigla: "CESCAGE",
    estado: "PR",
  },
  {
    nome: "FACULDADES INTEGRADAS EINSTEIN DE LIMEIRA",
    sigla: "FIEL",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS ESPÍRITA",
    sigla: "FIES",
    estado: "PR",
  },
  {
    nome: "FACULDADES INTEGRADAS ESPÍRITOSANTENSE",
    sigla: "FAESA",
    estado: "ES",
  },
  {
    nome: "FACULDADES INTEGRADAS HÉLIO ALONSO",
    sigla: "FACHA",
    estado: "RJ",
  },
  {
    nome: "FACULDADES INTEGRADAS INTERAMERICANAS",
    sigla: "FAITER",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS IPIRANGA",
    sigla: "FAINTIPI",
    estado: "PA",
  },
  {
    nome: "FACULDADES INTEGRADAS IPITANGA",
    sigla: "UNIBAHIA",
    estado: "BA",
  },
  {
    nome: "FACULDADES INTEGRADAS MARIA IMACULADA",
    sigla: "FIMI",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS MARIA THEREZA",
    sigla: "FAMATH",
    estado: "RJ",
  },
  {
    nome: "FACULDADES INTEGRADAS MATO-GROSSENSES DE CIÊNCIAS SOCIAIS E HUMANAS",
    sigla: "ICE",
    estado: "MT",
  },
  {
    nome: "FACULDADES INTEGRADAS OLGA METTIG",
    sigla: "FAMETTIG",
    estado: "BA",
  },
  {
    nome: "FACULDADES INTEGRADAS PADRE ALBINO",
    sigla: "FIPA",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS PITÁGORAS",
    sigla: "FIP-MOC",
    estado: "MG",
  },
  {
    nome: "FACULDADES INTEGRADAS REGIONAIS DE AVARÉ",
    sigla: "FIRA",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS RIO BRANCO",
    sigla: "FIRB",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS RIO BRANCO",
    sigla: "FRB",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS RUI BARBOSA",
    sigla: "FIRB",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS SANTA CRUZ DE CURITIBA",
    sigla: "FARESC",
    estado: "PR",
  },
  {
    nome: "FACULDADES INTEGRADAS SOARES DE OLIVEIRA",
    sigla: "FISO",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS STELLA MARIS DE ANDRADINA",
    sigla: "FISMA",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS SÉVIGNÉ",
    sigla: "FAE SÉVIGNÉ",
    estado: "RS",
  },
  {
    nome: "FACULDADES INTEGRADAS TERESA D´ÁVILA",
    sigla: "FATEA",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS URUBUPUNGÁ",
    sigla: "FIU",
    estado: "SP",
  },
  {
    nome: "FACULDADES INTEGRADAS VIANNA JÚNIOR",
    sigla: "FIVJ",
    estado: "MG",
  },
  {
    nome: "FACULDADES INTEGRADAS",
    sigla: "UPIS",
    estado: "DF",
  },
  {
    nome: "FACULDADES ITECNE DE CASCAVEL",
    sigla: "ITECNE",
    estado: "PR",
  },
  {
    nome: "FACULDADES MAGSUL",
    sigla: "FAMAG",
    estado: "MS",
  },
  {
    nome: "FACULDADES MILTON CAMPOS",
    sigla: "FMC",
    estado: "MG",
  },
  {
    nome: "FACULDADES NORDESTE",
    sigla: "Fanor",
    estado: "CE",
  },
  {
    nome: "FACULDADES OSWALDO CRUZ",
    sigla: "FOC",
    estado: "SP",
  },
  {
    nome: "FACULDADES PEQUENO PRÍNCIPE",
    sigla: "FPP",
    estado: "PR",
  },
  {
    nome: "FACULDADES SANTO AGOSTINHO",
    sigla: "FSA",
    estado: "MG",
  },
  {
    nome: "FACULDADES SPEI",
    sigla: "FACSPEI",
    estado: "PR",
  },
  {
    nome: "FACULDADES UNIDAS DE PESQUISA CIÊNCIAS E SAÚDE LTDA",
    sigla: "FAPEC",
    estado: "BA",
  },
  {
    nome: "FACULDADES UNIDAS DO NORTE DE MINAS",
    sigla: "Funorte",
    estado: "RO",
  },
  {
    nome: "FACULDADES UNIDAS DO VALE DO ARAGUAIA",
    sigla: "UNIVAR",
    estado: "MT",
  },
  {
    nome: "FACULDADES UNIFICADAS DE CATAGUASES",
    sigla: "FUC",
    estado: "MG",
  },
  {
    nome: "FACULDADES UNIFICADAS DE FOZ DO IGUAÇU",
    sigla: "UNIFOZ",
    estado: "PR",
  },
  {
    nome: "FACULDADES UNIFICADAS DE GUARAPARI",
    sigla: "FUG",
    estado: "ES",
  },
  {
    nome: "FACULDADES UNIFICADAS DE IÚNA",
    sigla: "FUI",
    estado: "ES",
  },
  {
    nome: "FACULDADES UNIFICADAS DE TEÓFILO OTONI",
    sigla: "FUTO",
    estado: "MG",
  },
  {
    nome: "FACULDADES VALE DO CARANGOLA",
    sigla: "FAVALEUEMG",
    estado: "MG",
  },
  {
    nome: "FAE CENTRO UNIVERSITÁRIO",
    sigla: "FAE",
    estado: "PR",
  },
  {
    nome: "FAJOPA - FACULDADE JOÃO PAULO II",
    sigla: "FAJOPA",
    estado: "SP",
  },
  {
    nome: "FEFISA - FACULDADES INTEGRADAS DE SANTO ANDRÉ",
    sigla: "FEFISA",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO ARMANDO ÁLVARES PENTEADO",
    sigla: "FAAP",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO ASSIS GURGACZ",
    sigla: "FAG",
    estado: "PR",
  },
  {
    nome: "FUNDAÇÃO COMUNITÁRIA DE ENSINO SUPERIOR DE ITABIRA",
    sigla: "FUNCESI",
    estado: "MG",
  },
  {
    nome: "FUNDAÇÃO CÁSPER LÍBERO",
    sigla: "FCL",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO DE ENSINO SUPERIOR DE CLEVELÂNDIA",
    sigla: "FESC",
    estado: "PR",
  },
  {
    nome: "FUNDAÇÃO DE ENSINO SUPERIOR DE PASSOS",
    sigla: "FESP",
    estado: "MG",
  },
  {
    nome: "FUNDAÇÃO EDUCACIONAL ARAÇATUBA",
    sigla: "FEA",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO EDUCACIONAL DE DIVINÓPOLIS",
    sigla: "FUNEDI",
    estado: "MG",
  },
  {
    nome: "FUNDAÇÃO ESCOLA DE COMÉRCIO ÁLVARES PENTEADO",
    sigla: "FECAP",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO ESCOLA DE SOCIOLOGIA E POLÍTICA DE SÃO PAULO",
    sigla: "FESPSP",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO GETÚLIO VARGAS",
    sigla: "FGV",
    estado: "RJ",
  },
  {
    nome: "FUNDAÇÃO GETÚLIO VARGAS",
    sigla: "FGV",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO INSTITUTO CAPIXABA DE PESQUISAS EM CONTABILIDADE ECONOMIA E FINANÇAS",
    sigla: "FUCAPE",
    estado: "ES",
  },
  {
    nome: "FUNDAÇÃO INSTITUTO TECNOLÓGICO DE OSASCO",
    sigla: "FITO",
    estado: "SP",
  },
  {
    nome: "FUNDAÇÃO JOÃO PINHEIRO",
    sigla: "FJP",
    estado: "MG",
  },
  {
    nome: "FUNDAÇÃO MINEIRA DE EDUCAÇÃO E CULTURA",
    sigla: "FUMEC",
    estado: "MG",
  },
  {
    nome: "FUNDAÇÃO TÉCNICO EDUCACIONAL SOUZA MARQUES",
    sigla: "FTESM",
    estado: "RJ",
  },
  {
    nome: "FUNDAÇÃO UNIVERSIDADE DO TOCANTINS",
    sigla: "UNITINS",
    estado: "TO",
  },
  {
    nome: "FUNDAÇÃO UNIVERSIDADE FEDERAL DO VALE DO SÃO FRANCISCO",
    sigla: "UNIVASF",
    estado: "BA",
  },
  {
    nome: "FUNDAÇÃO UNIVERSIDADE FEDERAL DO VALE DO SÃO FRANCISCO",
    sigla: "UNIVASF",
    estado: "PE",
  },
  {
    nome: "FUNDAÇÃO UNIVERSIDADE REGIONAL DE BLUMENAU",
    sigla: "FURB",
    estado: "SC",
  },
  {
    nome: "GRUPO EDUCACIONAL UNINTER",
    sigla: "UNINTER",
    estado: "PR",
  },
  {
    nome: "INSTITUIÇÃO DE ENSINO SUPERIOR DO ACRE",
    sigla: "Iesacre",
    estado: "AC",
  },
  {
    nome: "INSTITUIÇÃO DE ENSINO SÃO FRANCISCO",
    sigla: "IESF",
    estado: "SP",
  },
  {
    nome: "INSTITUIÇÃO TOLEDO DE ENSINO",
    sigla: "ITE",
    estado: "SP",
  },
  {
    nome: "INSTITUTO ADVENTISTA CRUZEIRO DO SUL",
    sigla: "IACS",
    estado: "RS",
  },
  {
    nome: "INSTITUTO ADVENTISTA DE ENSINO DE SANTA CATARINA",
    sigla: "IAESC",
    estado: "SC",
  },
  {
    nome: "INSTITUTO BAIANO DE ENSINO SUPERIOR",
    sigla: "IBES",
    estado: "BA",
  },
  {
    nome: "INSTITUTO BELO HORIZONTE DE ENSINO SUPERIOR",
    sigla: "IBHES",
    estado: "MG",
  },
  {
    nome: "INSTITUTO BRASILEIRO DE MERCADO DE CAPITAIS",
    sigla: "IBMEC",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO CAMILLO FILHO",
    sigla: "ICF",
    estado: "PI",
  },
  {
    nome: "INSTITUTO CENECISTA DE ENSINO SUPERIOR DE SANTO ÂNGELO",
    sigla: "IESA",
    estado: "RS",
  },
  {
    nome: "INSTITUTO CIENTÍFICO DE ENSINO SUPERIOR E PESQUISA",
    sigla: "Unicesp",
    estado: "DF",
  },
  {
    nome: "INSTITUTO CUIABÁ DE ENSINO E CULTURA",
    sigla: "ICEC",
    estado: "MT",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS BIOLÓGICAS",
    sigla: "ICB",
    estado: "PE",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS DA SAÚDE",
    sigla: "ICS",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS EXATAS",
    sigla: "UNEB",
    estado: "DF",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS JURÍDICAS E SOCIAIS PROFESSOR CAMILLO FILHO",
    sigla: "ICF",
    estado: "PI",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS SOCIAIS APLICADAS",
    sigla: "UNEB",
    estado: "DF",
  },
  {
    nome: "INSTITUTO DE CIÊNCIAS SOCIAIS E HUMANAS",
    sigla: "ICSH",
    estado: "GO",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO CENECISTA MARQUÊS DE HERVAL",
    sigla: "MARQUÊS",
    estado: "RS",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO E ENSINO SUPERIOR DE CAMPINAS",
    sigla: "IESCAMP",
    estado: "SP",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR DA PARAÍBA",
    sigla: "IESP",
    estado: "PB",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR DE BOITUVA",
    sigla: "FIB",
    estado: "SP",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR DE BRASÍLIA",
    sigla: "IESB",
    estado: "DF",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR DE PATROCÍNIO",
    sigla: "IESP",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR RAIMUNDO SÁ",
    sigla: "IESRSA",
    estado: "PI",
  },
  {
    nome: "INSTITUTO DE EDUCAÇÃO SUPERIOR UNYAHNA DE SALVADOR",
    sigla: "IESUS",
    estado: "BA",
  },
  {
    nome: "INSTITUTO DE ENSINO E PESQUISA OBJETIVO",
    sigla: "IEPO",
    estado: "TO",
  },
  {
    nome: "INSTITUTO DE ENSINO E PESQUISA",
    sigla: "Insper",
    estado: "SP",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR CENECISTA",
    sigla: "INESC",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DA FUPESP",
    sigla: "IESF",
    estado: "SP",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DA GRANDE FLORIANÓPOLIS",
    sigla: "IESGF",
    estado: "SC",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DE LONDRINA - INESUL",
    sigla: "INESUL",
    estado: "PR",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DE OLINDA",
    sigla: "IESO",
    estado: "PE",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DE PIEDADE",
    sigla: "IESP",
    estado: "PE",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DE RIO VERDE",
    sigla: "IESRIVER",
    estado: "GO",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DE RONDÔNIA",
    sigla: "IESUR",
    estado: "RO",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DO RIO GRANDE DO NORTE",
    sigla: "IESRN",
    estado: "RN",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR DO SUL DO MARANHÃO",
    sigla: "IESMA",
    estado: "MA",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR E FORMAÇÃO AVANÇADA DE VITÓRIA",
    sigla: "FAVI",
    estado: "ES",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR FUCAPI",
    sigla: "Cesf",
    estado: "AM",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR INTEGRADO-IESI",
    sigla: "FENORD",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR JOÃO ALFREDO DE ANDRADE",
    sigla: "IJAA",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR PRESIDENTE TANCREDO NEVES",
    sigla: "IPTAN",
    estado: "MG",
  },
  {
    nome: "INSTITUTO DE ENSINO SUPERIOR SANTO ANTÔNIO",
    sigla: "INESA",
    estado: "SC",
  },
  {
    nome: "INSTITUTO DE ENSINOS SUPERIORES DA AMAZÔNIA",
    sigla: "IESAM",
    estado: "PA",
  },
  {
    nome: "INSTITUTO DE FILOSOFIA E TEOLOGIA DE GOIÁS",
    sigla: "IFITEG",
    estado: "GO",
  },
  {
    nome: "INSTITUTO DE PÓSGRADUAÇÃO",
    sigla: "IPOG",
    estado: "GO",
  },
  {
    nome: "INSTITUTO DE PÓSGRADUAÇÃO",
    sigla: "IPOG",
    estado: "RN",
  },
  {
    nome: "INSTITUTO EDUCACIONAL DE CASTRO",
    sigla: "INEC",
    estado: "PR",
  },
  {
    nome: "INSTITUTO EDUCACIONAL VITÓRIA",
    sigla: "INEVI",
    estado: "PE",
  },
  {
    nome: "INSTITUTO FEDERAL BAIANO",
    sigla: "IF Baiano",
    estado: "BA",
  },
  {
    nome: "INSTITUTO FEDERAL CATARINENSE",
    sigla: "IFC",
    estado: "SC",
  },
  {
    nome: "INSTITUTO FEDERAL DA BAHIA",
    sigla: "IFBA",
    estado: "BA",
  },
  {
    nome: "INSTITUTO FEDERAL DA PARAÍBA",
    sigla: "IFPB",
    estado: "PB",
  },
  {
    nome: "INSTITUTO FEDERAL DE ALAGOAS",
    sigla: "Ifal",
    estado: "AL",
  },
  {
    nome: "INSTITUTO FEDERAL DE BRASÍLIA",
    sigla: "IFB",
    estado: "DF",
  },
  {
    nome: "INSTITUTO FEDERAL DE EDUCAÇÃO CIÊNCIA E TECNOLOGIA DE SÃO PAULO",
    sigla: "IFSP",
    estado: "SP",
  },
  {
    nome: "INSTITUTO FEDERAL DE EDUCAÇÃO CIÊNCIA E TECNOLOGIA DO NORTE DE MINAS GERAIS",
    sigla: "IFNMG",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL DE EDUCAÇÃO CIÊNCIA E TECNOLOGIA SUL-RIO-GRANDENSE",
    sigla: "IFSul",
    estado: "RS",
  },
  {
    nome: "INSTITUTO FEDERAL DE GOIÁS",
    sigla: "IFG",
    estado: "GO",
  },
  {
    nome: "INSTITUTO FEDERAL DE MATO GROSSO DO SUL",
    sigla: "IFMS",
    estado: "MS",
  },
  {
    nome: "INSTITUTO FEDERAL DE MINAS GERAIS",
    sigla: "IFMG",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL DE PERNAMBUCO",
    sigla: "IFPE",
    estado: "PE",
  },
  {
    nome: "INSTITUTO FEDERAL DE RONDÔNIA",
    sigla: "IFRO",
    estado: "RO",
  },
  {
    nome: "INSTITUTO FEDERAL DE RORAIMA",
    sigla: "IFRR",
    estado: "RR",
  },
  {
    nome: "INSTITUTO FEDERAL DE SANTA CATARINA",
    sigla: "IFSC",
    estado: "SC",
  },
  {
    nome: "INSTITUTO FEDERAL DE SERGIPE",
    sigla: "IFS",
    estado: "SE",
  },
  {
    nome: "INSTITUTO FEDERAL DO ACRE",
    sigla: "IFAC",
    estado: "AC",
  },
  {
    nome: "INSTITUTO FEDERAL DO AMAPÁ",
    sigla: "Ifap",
    estado: "AP",
  },
  {
    nome: "INSTITUTO FEDERAL DO AMAZONAS",
    sigla: "Ifam",
    estado: "AM",
  },
  {
    nome: "INSTITUTO FEDERAL DO CEARÁ",
    sigla: "Ifce",
    estado: "CE",
  },
  {
    nome: "INSTITUTO FEDERAL DO ESPÍRITO SANTO",
    sigla: "IFES",
    estado: "ES",
  },
  {
    nome: "INSTITUTO FEDERAL DO MARANHÃO",
    sigla: "IFMA",
    estado: "MA",
  },
  {
    nome: "INSTITUTO FEDERAL DO MATO GROSSO",
    sigla: "IFMT",
    estado: "MT",
  },
  {
    nome: "INSTITUTO FEDERAL DO NORTE DE MINAS",
    sigla: "IFNM",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL DO PARÁ",
    sigla: "IFPA",
    estado: "PA",
  },
  {
    nome: "INSTITUTO FEDERAL DO PIAUÍ",
    sigla: "IFPI",
    estado: "PI",
  },
  {
    nome: "INSTITUTO FEDERAL DO RIO DE JANEIRO",
    sigla: "IFRJ",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO FEDERAL DO RIO GRANDE DO NORTE",
    sigla: "IFRN",
    estado: "RN",
  },
  {
    nome: "INSTITUTO FEDERAL DO RIO GRANDE DO SUL",
    sigla: "IFRS",
    estado: "RS",
  },
  {
    nome: "INSTITUTO FEDERAL DO SERTÃO PERNAMBUCANO",
    sigla: "IFSertãoPE",
    estado: "PE",
  },
  {
    nome: "INSTITUTO FEDERAL DO SUDESTE DE MINAS",
    sigla: "IFSM",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL DO SUL DE MINAS",
    sigla: "IFSUM",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL DO TOCANTINS",
    sigla: "IFTO",
    estado: "TO",
  },
  {
    nome: "INSTITUTO FEDERAL DO TRIÂNGULO MINEIRO",
    sigla: "IFTM",
    estado: "MG",
  },
  {
    nome: "INSTITUTO FEDERAL FARROUPILHA",
    sigla: "IFFarroupilha",
    estado: "RS",
  },
  {
    nome: "INSTITUTO FEDERAL FLUMINENSE",
    sigla: "IFF",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO FEDERAL GOIANO",
    sigla: "IF Goiano",
    estado: "GO",
  },
  {
    nome: "INSTITUTO FLORENCE DE ENSINO SUPERIOR",
    sigla: "IFES",
    estado: "MA",
  },
  {
    nome: "INSTITUTO INFNET RIO DE JANEIRO",
    sigla: "INFNET",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO INFNET",
    sigla: "INFNET",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO ITAPETININGANO DE ENSINO SUPERIOR",
    sigla: "IIES",
    estado: "SP",
  },
  {
    nome: "INSTITUTO JORDÃO DE ARRUDA",
    sigla: "INSJAR",
    estado: "GO",
  },
  {
    nome: "INSTITUTO LUTERANO DE ENSINO SUPERIOR DE PORTO VELHO",
    sigla: "ILES/ULBRA",
    estado: "RO",
  },
  {
    nome: "INSTITUTO MANCHESTER PAULISTA DE ENSINO SUPERIOR",
    sigla: "IMAPES",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MATONENSE MUNICIPAL DE ENSINO SUPERIOR",
    sigla: "IMMES",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MAUÁ DE TECNOLOGIA",
    sigla: "IMT",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MAUÁ DE TECNOLOGIA",
    sigla: "IMT",
    estado: "SP",
  },
  {
    nome: "INSTITUTO METODISTA BENNETT",
    sigla: "BENNETT",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO METROPOLITANO DE ENSINO SUPERIOR",
    sigla: "IMES",
    estado: "MG",
  },
  {
    nome: "INSTITUTO MILITAR DE ENGENHARIA",
    sigla: "IME",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE ASSIS",
    sigla: "IMESA",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE BEBEDOURO VICTÓRIO CARDASSI",
    sigla: "IMESB",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE CATANDUVA",
    sigla: "IMES Catanduva",
    estado: "SP",
  },
  {
    nome: "INSTITUTO MUNICIPAL DE ENSINO SUPERIOR DE SÃO MANUEL",
    sigla: "IMESSM",
    estado: "SP",
  },
  {
    nome: "INSTITUTO NACIONAL DE EDUCAÇÃO DE SURDOS",
    sigla: "INES",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO NACIONAL DE ENSINO SUPERIOR E PÓS-GRADUAÇÃO PADRE GERVÁSIO",
    sigla: "INAPÓS",
    estado: "MG",
  },
  {
    nome: "INSTITUTO NACIONAL DE TELECOMUNICAÇÕES",
    sigla: "INATEL",
    estado: "MG",
  },
  {
    nome: "INSTITUTO PARAIBANO DE ENSINO RENOVADO",
    sigla: "INPER",
    estado: "PB",
  },
  {
    nome: "INSTITUTO PAULISTA DE ENSINO",
    sigla: "FIPEN",
    estado: "SP",
  },
  {
    nome: "INSTITUTO PERNAMBUCANO DE ENSINO SUPERIOR",
    sigla: "IPESU",
    estado: "PE",
  },
  {
    nome: "INSTITUTO PERNAMBUCO DE ENSINO E CULTURA",
    sigla: "IPEC",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SALESIANO DE FILOSOFIA",
    sigla: "INSAF",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SANTO TOMÁS DE AQUINO",
    sigla: "ISTA",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE CIÊNCIAS APLICADAS - ISCA",
    sigla: "ISCA",
    estado: "SP",
  },
  {
    nome: "INSTITUTO SUPERIOR DE CIÊNCIAS HUMANAS E SOCIAIS ANÍSIO TEIXEIRA",
    sigla: "ISAT",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ALBERT EINSTEIN",
    sigla: "ISALBE",
    estado: "DF",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ALMEIDA RODRIGUES",
    sigla: "ISEAR",
    estado: "GO",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ALVORADA PLUS",
    sigla: "ISEAP",
    estado: "SP",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ANCHIETA",
    sigla: "ISEA",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ANTONINO FREIRE",
    sigla: "ISEAF",
    estado: "PI",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE CAMPOS GERAIS",
    sigla: "ISEC",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE FLORESTA",
    sigla: "ISEF",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE GOIANA",
    sigla: "ISEG",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE PESQUEIRA",
    sigla: "ISEP",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE SALGUEIRO",
    sigla: "ISES",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DE SÃO PAULO",
    sigla: "SINGULARIDADES/ISESP",
    estado: "SP",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DO CENTRO EDUCACIONAL NOSSA SENHORA AUXILIADORA",
    sigla: "ISECENSA",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DO MUNICÍPIO DE ITAPERUNA",
    sigla: "ISEMI",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DO SERTÃO DO PAJEÚ",
    sigla: "ISESP",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO DO VALE DO JURUENA",
    sigla: "AJES",
    estado: "MT",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ELVIRA DAYRELL",
    sigla: "ISEED",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO FRANCISCANO NOSSA SENHORA DE FÁTIMA",
    sigla: "FATIMA",
    estado: "DF",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO ORÍGENES LESSA",
    sigla: "ISEOL",
    estado: "SP",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO PAULO MARTINS",
    sigla: "ISPAM",
    estado: "DF",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO PROFESSOR ALDO MUYLAERT",
    sigla: "ISEPAM",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO PROFESSORA NAIR FORTES ABU-MERHY",
    sigla: "ISEFOR",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO SANTA CRUZ",
    sigla: "ISED",
    estado: "PE",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO SÃO JUDAS TADEU",
    sigla: "ISESJT",
    estado: "PI",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO UNIÃO DAS AMÉRICAS",
    sigla: "UNIAMÉRICA",
    estado: "PR",
  },
  {
    nome: "INSTITUTO SUPERIOR DE EDUCAÇÃO VERDE NORTE",
    sigla: "FAVENORTE",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE ENSINO E PESQUISA DE ITUIUTABA",
    sigla: "ISEPI",
    estado: "MG",
  },
  {
    nome: "INSTITUTO SUPERIOR DE FILOSOFIA BERTHIER",
    sigla: "IFIBE",
    estado: "RS",
  },
  {
    nome: "INSTITUTO SUPERIOR DE TECNOLOGIA EM CIÊNCIAS DA COMPUTAÇÃO DE PARACAMBI",
    sigla: "ISTParacambi",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE TECNOLOGIA EM CIÊNCIAS DA COMPUTAÇÃO DE PETRÓPOLIS",
    sigla: "ISTCCP",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE TECNOLOGIA EM CIÊNCIAS DA COMPUTAÇÃO DO RIO DE JANEIRO",
    sigla: "ISTRio",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO SUPERIOR DE TEOLOGIA APLICADA",
    sigla: "Ista",
    estado: "CE",
  },
  {
    nome: "INSTITUTO SUPERIOR DO LITORAL DO PARANÁ",
    sigla: "ISULPAR",
    estado: "PR",
  },
  {
    nome: "INSTITUTO SUPERIOR E CENTRO EDUCACIONAL LUTERANO - BOM JESUS - IELUSC",
    sigla: "BOM JESUS/IELUSC",
    estado: "SC",
  },
  {
    nome: "INSTITUTO SÃO PAULO DE FORMAÇÃO E ESPECIALIZAÇÃO PROFISSIONAL",
    sigla: "UniSãopaulo",
    estado: "SP",
  },
  {
    nome: "INSTITUTO TAQUARITINGUENSE DE ENSINO SUPERIOR DR. ARISTIDES DE CARVALHO SCHLOBACH",
    sigla: "ITES",
    estado: "SP",
  },
  {
    nome: "INSTITUTO TAUBATÉ DE ENSINO SUPERIOR",
    sigla: "I.T.E.S.",
    estado: "SP",
  },
  {
    nome: "INSTITUTO TECNOLÓGICO DE AERONÁUTICA",
    sigla: "ITA",
    estado: "SP",
  },
  {
    nome: "INSTITUTO TECNOLÓGICO DE CARATINGA",
    sigla: "ITC",
    estado: "MG",
  },
  {
    nome: "INSTITUTO TECNOLÓGICO E DAS CIÊNCIAS SOCIAIS APLICADAS E DA SAÚDE DO CENTRO EDUC. N. SRª AUXILIADORA",
    sigla: "ITCSAS/CENSA",
    estado: "RJ",
  },
  {
    nome: "INSTITUTO TOCANTINENSE PRESIDENTE ANTÔNIO CARLOS DE PORTO NACIONAL",
    sigla: "ITPAC de Porto Nacional",
    estado: "TO",
  },
  {
    nome: "INSTITUTO TOCANTINENSE PRESIDENTE ANTÔNIO CARLOS",
    sigla: "ITPAC",
    estado: "TO",
  },
  {
    nome: "INSTITUTO UNIFICADO DE ENSINO SUPERIOR OBJETIVO",
    sigla: "IUESO",
    estado: "GO",
  },
  {
    nome: "MATER CHRISTI",
    sigla: "Faculdade",
    estado: "RN",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DE CAMPINAS",
    sigla: "PUCCampinas",
    estado: "SP",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DE GOIÁS",
    sigla: "PUC",
    estado: "GO",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DE MINAS GERAIS",
    sigla: "PUCMG",
    estado: "MG",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DE SÃO PAULO",
    sigla: "PUCSP",
    estado: "SP",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DO PARANÁ",
    sigla: "PUCPR",
    estado: "PR",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DO RIO DE JANEIRO",
    sigla: "PUCRIO",
    estado: "RJ",
  },
  {
    nome: "PONTIFÍCIA UNIVERSIDADE CATÓLICA DO RIO GRANDE DO SUL",
    sigla: "PUCRS",
    estado: "RS",
  },
  {
    nome: "SERVIÇO NACIONAL DE APRENDIZAGEM INDUSTRIAL",
    sigla: "SENAI/CIMATEC ",
    estado: "BA",
  },
  {
    nome: "SOCIEDADE EDUCACIONAL DE SANTA CATARINA",
    sigla: "SOCIESC",
    estado: "SC",
  },
  {
    nome: "SOCIEDADE UNIVERSITÁRIA REDENTOR",
    sigla: "REDENTOR",
    estado: "RJ",
  },
  {
    nome: "TREVISAN ESCOLA SUPERIOR DE NEGÓCIOS",
    sigla: "TREVISAN",
    estado: "SP",
  },
  {
    nome: "UNIDADE DE ENSINO SUPERIOR DOM BOSCO",
    sigla: "UNDB",
    estado: "MA",
  },
  {
    nome: "UNIDADE DE ENSINO SUPERIOR EXPOENTE",
    sigla: "UNIEXP",
    estado: "PR",
  },
  {
    nome: "UNISA  FACULDADE DE FILOSOFIA CIÊNCIAS E LETRAS DO ALTO SÃO FRANCISCO",
    sigla: "FASF",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE ALTO VALE DO RIO DO PEIXE",
    sigla: "UNIARP",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE ANHANGUERA",
    sigla: "Unianhanguera",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE ANHEMBI MORUMBI",
    sigla: "UAM",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE BANDEIRANTE DE SÃO PAULO",
    sigla: "UNIBAN",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE BARRIGA VERDE",
    sigla: "UNIBAVE",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE BRAZ CUBAS",
    sigla: "UBC",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE CAMILO CASTELO BRANCO",
    sigla: "UNICASTELO",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE CASTELO BRANCO",
    sigla: "UCB",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DE BRASÍLIA",
    sigla: "UCB",
    estado: "DF",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DE PELOTAS",
    sigla: "UCPEL",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DE PERNAMBUCO",
    sigla: "UNICAP",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DE SALVADOR",
    sigla: "UCSAL ",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DE SANTOS",
    sigla: "UNISANTOS",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE CATÓLICA DOM BOSCO",
    sigla: "UCDB",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE COMUNITÁRIA REGIONAL DE CHAPECÓ",
    sigla: "UNOCHAPECÓ",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE CRUZEIRO DO SUL",
    sigla: "UNICSUL",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE CÂNDIDO MENDES",
    sigla: "UCAM",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE DA AMAZÔNIA",
    sigla: "UNAMA",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE DA INTEGRAÇÃO INTERNACIONAL DA LUSOFONIA AFRO-BRASILEIRA",
    sigla: "UNILAB",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE DA REGIÃO DA CAMPANHA",
    sigla: "URCAMP",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DA REGIÃO DE JOINVILLE",
    sigla: "UNIVILLE",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DE ALFENAS JOSÉ DO ROSÁRIO VELLANO",
    sigla: "UNIFENAS",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE DE BRASÍLIA",
    sigla: "UnB",
    estado: "DF",
  },
  {
    nome: "UNIVERSIDADE DE CAXIAS DO SUL",
    sigla: "UCS",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DE CRUZ ALTA",
    sigla: "UNICRUZ",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DE CUIABÁ",
    sigla: "UNIC",
    estado: "MT",
  },
  {
    nome: "UNIVERSIDADE DE FORTALEZA",
    sigla: "Unifor",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE DE FRANCA",
    sigla: "UNIFRAN",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE GUARULHOS",
    sigla: "UNG",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE ITAÚNA",
    sigla: "UIT",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE DE MARÍLIA",
    sigla: "UNIMAR",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE MOGI DAS CRUZES",
    sigla: "UMC",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE PASSO FUNDO",
    sigla: "UPF",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DE RIBEIRÃO PRETO",
    sigla: "UNAERP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE RIO VERDE2",
    sigla: "FESURV",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE DE SANTA CRUZ DO SUL",
    sigla: "UNISC",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DE SOROCABA",
    sigla: "UNISO",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE SÃO PAULO",
    sigla: "USP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE TAUBATÉ",
    sigla: "UNITAU",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DE UBERABA",
    sigla: "UNIUBE",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE DO CEUMA - UNICEUMA",
    sigla: "UNICEUMA",
    estado: "MA",
  },
  {
    nome: "UNIVERSIDADE DO CONTESTADO",
    sigla: "UNC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DA BAHIA",
    sigla: "UNEB",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DE MATO GROSSO",
    sigla: "UNEMAT",
    estado: "MT",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DE MINAS GERAIS",
    sigla: "UEMG",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DE SANTA CATARINA",
    sigla: "UDESC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DO AMAZONAS",
    sigla: "Uea",
    estado: "AM",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DO PARÁ",
    sigla: "UEPA",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DO RIO DE JANEIRO",
    sigla: "UERJ",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE DO ESTADO DO RIO GRANDE DO NORTE",
    sigla: "UERN",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE DO EXTREMO SUL CATARINENSE",
    sigla: "UNESC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO GRANDE ABC",
    sigla: "UniABC",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DO GRANDE RIO PROFESSOR JOSÉ DE SOUZA HERDY",
    sigla: "UNIGRANRIO",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE DO GRANDE RIO",
    sigla: "UNIGRANRIO",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE DO NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE DO OESTE DE SANTA CATARINA",
    sigla: "UNOESC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO OESTE PAULISTA",
    sigla: "UNOESTE",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DO PLANALTO CATARINENSE",
    sigla: "UNIPLAC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO SAGRADO CORAÇÃO",
    sigla: "USC",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DO SUL DE SANTA CATARINA",
    sigla: "UNISUL",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO VALE DO ITAJAÍ",
    sigla: "UNIVALI",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE DO VALE DO PARAÍBA",
    sigla: "UNIVAP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE DO VALE DO RIO DOS SINOS",
    sigla: "UNISINOS",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE DO VALE DO SAPUCAÍ",
    sigla: "UNIVAS",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE ELETRÔNICA DO BRASIL",
    sigla: "UEB",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DA PARAÍBA",
    sigla: "UEPB",
    estado: "PB",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DA ZONA OESTE",
    sigla: "UEZO",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE ALAGOAS",
    sigla: "Uneal",
    estado: "AL",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE CAMPINAS",
    sigla: "UNICAMP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE CIÊNCIAS DA SAÚDE DE ALAGOAS",
    sigla: "Uncisal",
    estado: "AL",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE FEIRA DE SANTANA",
    sigla: "UEFS",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE GOIÁS",
    sigla: "UEG",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE LONDRINA",
    sigla: "UEL",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE MARINGÁ",
    sigla: "UEM",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE MONTES CLAROS",
    sigla: "UNIMONTES",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE PONTA GROSSA",
    sigla: "UEPG",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE RORAIMA",
    sigla: "UERR",
    estado: "RR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DE SANTA CRUZ",
    sigla: "UESC",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO AMAPÁ",
    sigla: "Ueap",
    estado: "AP",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO CEARÁ",
    sigla: "Uece",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO CENTROOESTE",
    sigla: "UNICENTRO",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO MARANHÃO",
    sigla: "UEMA",
    estado: "MA",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO MATO GROSSO DO SUL",
    sigla: "UEMS",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO NORTE DO PARANÁ",
    sigla: "UENP",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO NORTE FLUMINENSE",
    sigla: "UENF",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO OESTE DO PARANÁ",
    sigla: "UNIOESTE",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO PARANÁ",
    sigla: "UNESPAR",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO PIAUÍ",
    sigla: "UESPI",
    estado: "PI",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO RIO GRANDE DO SUL",
    sigla: "UERGS",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL DO SUDOESTE DA BAHIA",
    sigla: "UESB",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL PAULISTA JÚLIO DE MESQUITA FILHO",
    sigla: "UNESP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE ESTADUAL VALE DO ACARAÚ",
    sigla: "Uva",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE ESTÁCIO DE SÁ",
    sigla: "UNESA",
    estado: "ES",
  },
  {
    nome: "UNIVERSIDADE ESTÁCIO DE SÁ",
    sigla: "UNESA",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE ESTÁCIO DE SÁ",
    sigla: "UNESA",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE EVANGELICA",
    sigla: "UniEvangelica",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA BAHIA",
    sigla: "UFBA",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA FRONTEIRA DO SUL",
    sigla: "UFFS",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA FRONTEIRA DO SUL",
    sigla: "UFFS",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA FRONTEIRA SUL",
    sigla: "UFFS",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA GRANDE DOURADOS",
    sigla: "UFGD",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA INTEGRAÇÃO LATINOAMERICANA",
    sigla: "UNILA",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DA PARAÍBA",
    sigla: "UFPB",
    estado: "PB",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE ALAGOAS",
    sigla: "Ufal",
    estado: "AL",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE ALFENAS",
    sigla: "UNIFAL",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE CAMPINA GRANDE",
    sigla: "UFCG",
    estado: "PB",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE CIÊNCIAS DA SAÚDE DE PORTO ALEGRE",
    sigla: "UFCSPA",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE GOIÁS",
    sigla: "UFG",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE INTEGRAÇÃO LUSOAFRO",
    sigla: "UNILAB",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE ITAJUBÁ",
    sigla: "UNIFEI",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE JUIZ DE FORA",
    sigla: "UFJF",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE LAVRAS",
    sigla: "UFLA",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE MATO GROSSO",
    sigla: "UFMT",
    estado: "MT",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE MINAS GERAIS",
    sigla: "UFMG",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE OURO PRETO",
    sigla: "UFOP",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE PELOTAS",
    sigla: "UFPEL",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE PERNAMBUCO",
    sigla: "UFPE",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE RONDÔNIA",
    sigla: "UNIR",
    estado: "RO",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE RORAIMA",
    sigla: "UFRR",
    estado: "RR",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SANTA CATARINA",
    sigla: "UFSC",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SANTA MARIA",
    sigla: "UFSM",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SERGIPE",
    sigla: "UFS",
    estado: "SE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SÃO CARLOS",
    sigla: "UFSCAR",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SÃO JOÃO DELREI",
    sigla: "UFSJ",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE SÃO PAULO",
    sigla: "UNIFESP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE UBERLÂNDIA",
    sigla: "UFU",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DE VIÇOSA",
    sigla: "UFV",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO ABC",
    sigla: "UFABC",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO ACRE",
    sigla: "UFAC",
    estado: "AC",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO AMAPÁ",
    sigla: "Unifap",
    estado: "AP",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO AMAZONAS",
    sigla: "Ufam",
    estado: "AM",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO CEARÁ",
    sigla: "UFC",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO ESPÍRITO SANTO",
    sigla: "UFES",
    estado: "ES",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO ESTADO DO RIO DE JANEIRO",
    sigla: "UNIRIO",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO MARANHÃO",
    sigla: "UFMA",
    estado: "MA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO MATO GROSSO DO SUL",
    sigla: "UFMS",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO OESTE DO PARÁ",
    sigla: "UFOPA",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO PAMPA",
    sigla: "UNIPAMPA",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO PANTANAL",
    sigla: "UFPAN",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO PARANÁ",
    sigla: "UFPR",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO PARÁ",
    sigla: "UFPA",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO PIAUÍ",
    sigla: "UFPI",
    estado: "PI",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO RECÔNCAVO DA BAHIA",
    sigla: "UFRB",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO RIO DE JANEIRO",
    sigla: "UFRJ",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO RIO GRANDE DO NORTE",
    sigla: "UFRN",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO RIO GRANDE DO SUL",
    sigla: "UFRGS",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO RIO GRANDE",
    sigla: "FURG",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO TOCANTINS",
    sigla: "UFT",
    estado: "TO",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DO TRIÂNGULO MINEIRO",
    sigla: "UFTM",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL DOS VALES DO JEQUITINHONHA E MUCURI",
    sigla: "UFVJM",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE FEDERAL FLUMINENSE",
    sigla: "UFF",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DA AMAZÔNIA",
    sigla: "UFRA",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DE PERNAMBUCO",
    sigla: "UFRPE",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DE PERNAMBUCO",
    sigla: "UFRPE",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DE PERNAMBUCO",
    sigla: "UFRPE",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DO RIO DE JANEIRO",
    sigla: "UFRRJ",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE FEDERAL RURAL DO SEMIÁRIDO",
    sigla: "UFERSA",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE FEEVALE",
    sigla: "FEEVALE",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE FUMEC",
    sigla: "FUMEC",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE GAMA E SOUZA",
    sigla: "UGS",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE GAMA FILHO",
    sigla: "UGF",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE IBIRAPUERA",
    sigla: "UNIB",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE IGUAÇU",
    sigla: "UNIG",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE LUTERANA DO BRASIL",
    sigla: "ULBRA",
    estado: "AM",
  },
  {
    nome: "UNIVERSIDADE LUTERANA DO BRASIL",
    sigla: "ULBRA",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE LUTERANA DO BRASIL",
    sigla: "ULBRA",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE LUTERANA DO BRASIL",
    sigla: "ULBRA",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE LUTERANA DO BRASIL",
    sigla: "ULBRA",
    estado: "TO",
  },
  {
    nome: "UNIVERSIDADE METODISTA DE PIRACICABA",
    sigla: "UNIMEP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE METODISTA DE SÃO PAULO",
    sigla: "UMESP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE METROPOLITANA DE SANTOS",
    sigla: "UNIMES",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE MUNICIPAL DE SÃO CAETANO DO SUL",
    sigla: "USCS",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE MUNICIPAL DE SÃO JOSÉ",
    sigla: "USJ",
    estado: "SC",
  },
  {
    nome: "UNIVERSIDADE NILTON LINS",
    sigla: "UNINILTONLINS",
    estado: "AM",
  },
  {
    nome: "UNIVERSIDADE NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "DF",
  },
  {
    nome: "UNIVERSIDADE NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "ES",
  },
  {
    nome: "UNIVERSIDADE NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "SE",
  },
  {
    nome: "UNIVERSIDADE NOVE DE JULHO",
    sigla: "UNINOVE",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE PARA O DESENVOLVIMENTO DO ESTADO E REGIÃO DO PANTANAL",
    sigla: "UNIDERP",
    estado: "MS",
  },
  {
    nome: "UNIVERSIDADE PARANAENSE",
    sigla: "UNIPAR",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "UNIP",
    estado: "DF",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "UNIP",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "UNIP",
    estado: "PA",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "UNIP",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "UNIP",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE PAULISTA",
    sigla: "Unip",
    estado: "AM",
  },
  {
    nome: "UNIVERSIDADE POSITIVO",
    sigla: "UP",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE POTIGUAR",
    sigla: "UNP",
    estado: "RN",
  },
  {
    nome: "UNIVERSIDADE PRESBITERIANA MACKENZIE",
    sigla: "MACK",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE PRESIDENTE ANTÔNIO CARLOS",
    sigla: "UNIPAC",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE REGIONAL DO CARIRI",
    sigla: "Urca",
    estado: "CE",
  },
  {
    nome: "UNIVERSIDADE REGIONAL DO NOROESTE DO ESTADO DO RIO GRANDE DO SUL",
    sigla: "UNIJUÍ",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE REGIONAL INTEGRADA DO ALTO URUGUAI E DAS MISSÕES",
    sigla: "URI",
    estado: "RS",
  },
  {
    nome: "UNIVERSIDADE SALGADO DE OLIVEIRA",
    sigla: "UNIVERSO",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE SALGADO DE OLIVEIRA",
    sigla: "UNIVERSO",
    estado: "GO",
  },
  {
    nome: "UNIVERSIDADE SALGADO DE OLIVEIRA",
    sigla: "UNIVERSO",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE SALGADO DE OLIVEIRA",
    sigla: "UNIVERSO",
    estado: "PE",
  },
  {
    nome: "UNIVERSIDADE SALGADO DE OLIVEIRA",
    sigla: "UNIVERSO",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE SALVADOR",
    sigla: "UNIFACS",
    estado: "BA",
  },
  {
    nome: "UNIVERSIDADE SANTA CECÍLIA",
    sigla: "UNISANTA",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE SANTA ÚRSULA",
    sigla: "USU",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE SANTO AMARO",
    sigla: "UNISA",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE SEVERINO SOMBRA",
    sigla: "USS",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE SÃO FRANCISCO",
    sigla: "USF",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE SÃO JUDAS TADEU",
    sigla: "USJT",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE SÃO MARCOS",
    sigla: "UNIMARCO",
    estado: "SP",
  },
  {
    nome: "UNIVERSIDADE TECNOLÓGICA FEDERAL DO PARANÁ",
    sigla: "UTFPR",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE TIRADENTES",
    sigla: "Unit",
    estado: "SE",
  },
  {
    nome: "UNIVERSIDADE TIRADENTES",
    sigla: "UnitEAD",
    estado: "SE",
  },
  {
    nome: "UNIVERSIDADE TUIUTI DO PARANÁ",
    sigla: "UTP",
    estado: "PR",
  },
  {
    nome: "UNIVERSIDADE VALE DO RIO DOCE",
    sigla: "UNIVALE",
    estado: "MG",
  },
  {
    nome: "UNIVERSIDADE VEIGA DE ALMEIDA",
    sigla: "UVA",
    estado: "RJ",
  },
  {
    nome: "UNIVERSIDADE VILA VELHA",
    sigla: "UVV",
    estado: "ES",
  },
  {
    nome: "UNIVERSIDADE VIRTUAL DO MARANHÃO",
    sigla: "UNIVIMA",
    estado: "MA",
  },
  {
    nome: "UNIVERSIDADE Á DISTANCIA DO NORTE DO PARANÁ",
    sigla: "UNOPAR",
    estado: "RO",
  },
  {
    nome: "UNIVERSIDADES UNIDAS DO VALE DO ARAGUAIABARRA DO GARÇAS",
    sigla: "UNIVAR",
    estado: "MT",
  },
  {
    nome: "UNIÃO DAS ESCOLAS DO GRUPO FAIMI DE EDUCAÇÃO",
    sigla: "FAIMI",
    estado: "SP",
  },
  {
    nome: "UNIÃO DAS FACULDADES DOS GRANDES LAGOS",
    sigla: "UNILAGO",
    estado: "SP",
  },
  {
    nome: "UNIÃO DE ENSINO DO SUDOESTE DO PARANÁ",
    sigla: "UNISEP",
    estado: "PR",
  },
  {
    nome: "UNIÃO DE ENSINO SUPERIOR DE NOVA MUTUM",
    sigla: "UNINOVA",
    estado: "MT",
  },
  {
    nome: "UNIÃO DE ENSINO SUPERIOR DE VIÇOSA",
    sigla: "UNIVIÇOSA",
    estado: "MG",
  },
  {
    nome: "UNIÃO DE ESCOLAS SUPERIORES DA FUNESO",
    sigla: "UNESF",
    estado: "PE",
  },
  {
    nome: "UNIÃO DINÂMICA DE FACULDADES CATARATAS",
    sigla: "UDC",
    estado: "PR",
  },
  {
    nome: "UNIÃO EDUCACIONAL DE ENSINO SUPERIOR DO MÉDIO TOCANTINS",
    sigla: "UNEST",
    estado: "TO",
  },
  {
    nome: "UNIÃO EDUCACIONAL DO NORTE",
    sigla: "Uninorte",
    estado: "AC",
  },
  {
    nome: "UNIÃO LATINO-AMERICADA DE TECNOLOGIA",
    sigla: "ULT",
    estado: "PR",
  },
  {
    nome: "UNIÃO METROPOLITANA DE EDUCAÇÃO E CULTURA",
    sigla: "UNIME ",
    estado: "BA",
  },
];

export function filtered(q = "", page = 20) {
  if (q) {
    const data = LISTA_FACULDADES.filter(
      (e) =>
        e.nome.toLocaleLowerCase().includes(q.toLocaleLowerCase()) ||
        e.sigla.toLocaleLowerCase().includes(q.toLocaleLowerCase()),
    );

    return data.slice(page - 20, page);
  }

  const lista = LISTA_FACULDADES;

  return lista.slice(page - 20, page);
}
